module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_c('b', [_vm._v("IF IT’S HAPPENED ONCE, IT’S HAPPENED A THOUSAND TIMES.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some non-angler walks into my garage, takes one look around, and says: “Do you really need that many rods to catch fish?” I always answer that question with another question: “Do you play 18 holes of golf with nothing but a putter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No matter how you slice it, there is no one rod, reel, bait, or lure that will get the job done in every situation, or at least not get it done with as much success as gear tailored to each specific fishing task. Choosing the right tackle means thinking about far more than what kind of fish you plan to catch, because gear that’s perfectly suited to targeting trout in a lake could be totally ineffective for trout in a stream. How is that possible? Let’s assume you have an 8-foot rod and a reel spooled with 10-pound-test line. On the lake, that outfit will send a weighted rig a mile and get your bait to the fish. On a small stream, a rod that long might be much harder to maneuver if overhanging tree limbs and brush flank the water. The 10-pound line will be too stiff and heavy for the tiny trout spinners you’ll want to use, and won’t cast them half as far as a light, whippy 5-foot rod matched with thinner 6-pound-test line. Your surroundings, weight of baits and lures, distance you need to cast, and fighting ability of the fish you want to catch are just a few of the many factors that must be considered when gear shopping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This chapter is designed to give you a solid foundation in what tackle, baits, lures, and flies are necessary for a wide variety of fishing situations. It will also help you better understand how these key elements of angling success function, so you know exactly what you need and why when you walk into the tackle shop. You’ll also get some pointers on gear maintenance, as keeping your tackle well tuned is as important as changing the oil in your car.")]), _vm._v(" "), _c('h2', [_c('b', [_c('span', {
    staticClass: "col1"
  }, [_c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_vm._v(" USE THE 15 GREATEST LURES OF ALL TIME")])])]), _c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whether you target bass or walleyes, trout or stripers, salt- or freshwater fish, these are lures that actually work. Some are lures your granddad fished. Others have earned their reputation for productivity in more recent decades. In all cases, though, you’ll find a lure that catches fish, time after time.")]), _vm._v(" "), _c('div', {
    staticClass: "boxdd"
  }, [_c('h2', [_vm._v("KEY")]), _vm._v(" "), _c('p', {
    staticClass: "linew"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" BASS")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" TROUT")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" WALLEYE")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" PANFISH")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" PIKE/MUSKIE")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  }), _vm._v(" SALMON/STEELHEAD")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  }), _vm._v(" SALTWATER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("CURLY TAIL GRUB")]), _vm._v(" Combined with a plain or painted roundhead jig, these are arguably the most versatile fishing lures of all time.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MANN’S 1-MINUS")]), _vm._v(" This crankbait easily skims the top of barely submerged weedbeds. That’s often where the bass live.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RAPALA ORIGINAL FLOATER")]), _vm._v(" Loved by trout, bass, walleyes, and pike alike. Size F11 is great for all species, and black over silver is a top color.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("KASTMASTER")]), _vm._v(" Great for its lively tight wobble on a fairly fast retrieve and a broad shape that resembles a small freshwater shad.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-5.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("PANTHER MARTIN")]), _vm._v(" A staple from Montana to Maine, these spinners are perfect for picking trout from the pockets of steeply tumbling mountain creeks.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-6.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("CORDELL RED FIN")]), _vm._v(" The 7-inch, 1-ounce Smoky Joe–color Red Fin is a striper killer in both fresh and saltwater.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-7.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("REBEL POP-R")]), _vm._v(" There are lots of poppers on the market, but this one casts farther than most and spits water like no other.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-8.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("DARDEVLE SPINNIE")]), _vm._v(" Probably the world’s most recognized fishing lure, this spoon is as effective now as it was a century ago.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-9.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("PHOEBE")]), _vm._v(" One of the alltime great trout spoons. The ⅛-ounce gold version is deadly on small streams.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ROOSTER TAIL")]), _vm._v(" For large brown and rainbow trout in bigger rivers and lakes, this is the hot-ticket lure.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("JITTERBUG")]), _vm._v(" Cast this frog pattern hardbait across a summer cove, then watch it get crushed as it glub-glubs slowly back.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("SNAG-PROOF FROG")]), _vm._v(" You can throw one of these soft-plastic frogs just about anywhere; it won't get stuck in thick pads and cover.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-13.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("GIBBS PENCIL POPPER")]), _vm._v(" Cast with heavy surf gear, then reel s-l-o-w-l-y while using your right hand to whip the rod tip.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("YAMAMOTO SENKO")]), _vm._v(" The fluttering action of this soft-plastic lure as it falls is amazingly effective for large- and smallmouth bass.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-15.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MEPPS AGLIA")]), _vm._v(" Use a size o, "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("12")]), _vm._v("-ounce version with a silver blade to turn big trout in small and large streams.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  })])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t1"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t2"
    }
  }, [_vm._v("2 MEET 15 NEW CLASSICS")])])]), _c('a', {
    attrs: {
      "id": "t2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They’re definitely not your father’s lures (but he’ll probably want to borrow them from you). These crankbaits, soft plastics, and jigs—plus some that are in categories all their own—are the hottest baits on bass impoundments, walleye lakes, and trout streams today. And we’re betting anglers will be tying them on for decades, because what they do is catch fish consistently. Better start making room in your tackle box.")]), _vm._v(" "), _c('div', {
    staticClass: "boxdd"
  }, [_c('h2', [_vm._v("KEY")]), _vm._v(" "), _c('p', {
    staticClass: "linew"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" BASS")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" TROUT")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" WALLEYE")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" PANFISH")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" PIKE/MUSKIE")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  }), _vm._v(" SALMON/STEELHEAD")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  }), _vm._v(" SALTWATER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("SPRO PRIME BUCKTAIL")]), _vm._v(" Not all bucktails are created equally. The head shape and eye position of the Spro gives it a flutter that’s unmatched.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MUSKY INNOVATIONS BULL DAWG")]), _vm._v(" Its nose-down falling orientation and high-vibration tail turn trophy-muskie heads.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ZOOM FLUKE")]), _vm._v(" The Fluke is at its best when rigged weedless and worked in a twitch-fall pattern off the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RAPALA X-RAP")]), _vm._v(" Works best when twitched aggressively, producing an irresistible sideto-side slashing action.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-5.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("GULP! MINNOW")]), _vm._v(" If a fish eats baitfish, it’ll eat a Gulp! Minnow. This versatile soft bait comes in a range of sizes.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18f.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-6.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MANN’S STRETCH 25+")]), _vm._v(" These lures dive up to 30 feet deep unassisted when trolled, making them staples on saltwater boats.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-7.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("STRIKE PRO FLEX X")]), _vm._v(" Strike Pro’s segmented swimbait was revolutionary as the first lure to feature “bicycle chain” joints.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-8.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MUSKY MAYHEM DOUBLE COWGIRL")]), _vm._v(" Two giant blades swing in a wide rotation, making unparalleled vibrations.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-9.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("CAVITRON BUZZBAIT")]), _vm._v(" The wide blade keeps it on the surface at a slower turn rate, so it’s in the strike zone longer.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("YO-ZURI PIN’S MINNOW")]), _vm._v(" If you need to imitate some itty-bitty baitfish for trout or smallmouths, the 2¾;-inch Pin’s is the ticket.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("SÉBILE MAGIC SWIMMER")]), _vm._v(" The unique weight balance of this lure lets it continue swimming as it falls forward on the pause.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ORIGINAL ILANDER")]), _vm._v(" Marlin and wahoo will inhale it, and the blue-and-white model entices finicky bluefin tuna.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-13.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ZOOM BRUSH HOG")]), _vm._v(" This creature bait collects fewer weeds and is the ideal length and girth for Texas rigging.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("SHIMANO BUTTERFLY JIG")]), _vm._v(" This Japanese-style lure crushes everything from tuna to grouper to snappers.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18g.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-15.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box02"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("REBEL CRICKHOPPER")]), _vm._v(" This cricket-shaped crankbait flat-out slays every summer fish from panfish to trout to bass.")]), _vm._v(" "), _c('p', {
    staticClass: "hangz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.png"
    }
  })])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t2"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t3"
    }
  }, [_vm._v("3 MAKE OVER LURES WITH TOOTHPASTE")])])]), _c('a', {
    attrs: {
      "id": "t3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("An occasional cleaning with toothpaste can make your lures sparkle like new. It has a brightening agent and mild abrasives that restore lures to their original finish. Rinse them in warm water and then scrub gently with a soft-bristled toothbrush and toothpaste. This is particularly effective on spoons with a brass, copper, gold, or silver finish, which are much less attractive to fish when dull.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t3"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_vm._v("4 DO DIY CUSTOM LURE COLORS")])])]), _c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Permanent-ink felt-tipped markers are great for making on-the-scene pattern repairs to plastic fishing lures and for increasing their visibility under specific light conditions. Use black or blue to draw distinct scale patterns or vivid dark-light contrasts. Red is good for adding bright gill slashes. Make glaring eyes with yellow and black. Carry a few colors in your tackle box.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t4"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_vm._v("5 SECURE YOUR LURE")])])]), _c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put a drop of superglue on your hook or jighead shank before threading on any soft-plastic lure. The instant bond prevents the lure from slipping back on the hook with repeated casting. Soft plastics that slip down on the hook quickly lose their enticing action and often must be discarded long before they are worn out.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t5"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t6"
    }
  }, [_vm._v("6 TUNE A CRANKBAIT")])])]), _c('a', {
    attrs: {
      "id": "t6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The effectiveness of a crankbait depends primarily on how straight and deep it runs during a retrieve. Since anglers often bounce them off rocks, logs, or other bottom cover, these lures frequently get out of tune—which means they’ll begin running to one side, rolling over, vibrating improperly, or simply staying too shallow. Here’s how to get that crankbait into fish-catching shape:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" With a pocketknife, scrape the paint away from each hook holder (and the hook if it’s a sloppy paint job). This ensures that the trebles will swing freely from side to side, which allows maximum vibration and will prevent it rolling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Replace the round split ring on the line-tie eye with an oblong one to prevent your line from sliding into the split, which can keep a crankbait from diving properly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" If the crankbait runs to one side, say to the right, hold the lure with the bill facing you and, with a pair of needle-nose pliers, gently rotate the line-tie eye clockwise, so that the bottom of it (the edge facing you) moves slightly to the left. Don’t bend the eye; rotate it—and only a little bit. Make a short cast and retrieve quickly to see if you’ve corrected the problem. Repeat, if necessary, until the lure runs straight and true.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t6"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t7"
    }
  }, [_vm._v("7 KEEP LURES FROM HANGING UP")])])]), _c('a', {
    attrs: {
      "id": "t7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When deep-diving lures hang up on the bottom, the front or belly treble hook is usually to blame. To avoid snags, simply remove the front treble. The remaining rear treble hook will still catch fish. For further protection, add a split shot or two 18 inches ahead of the lure. This will keep the lure in a slightly head-down position that lifts the rear hook away from snags.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t7"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_vm._v("8 BUILD A BUDGET LURE")])])]), _c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the Great Depression, hard-up anglers crafted lures out of scrap wood and metal like this Copper Tube bait, which once filled tackle boxes across the nation and can be built on the cheap. These directions are for a bass lure, but you can make it in different sizes to catch everything from panfish to pike, and even muskies. For saltwater species, just substitute PVC pipe. Here’s how to make your own.")]), _vm._v(" "), _c('div', {
    staticClass: "boxa"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Place a 2¾-inch section of ½-inch-diameter copper plumbing pipe in a vise. Cut the front end of the pipe at a 45-degree angle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Sand each end to remove burrs that could nick fishing line.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Drill two ½-inch holes (top front and bottom rear), and again remove burrs.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" At this point, the lure will sink slowly. If you you want it to sink faster, seal the back with caulk, let dry, drop in three No. 5 split shot, and caulk the front. Now it’ll rattle, too.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Remove excess caulk and clean the lure, then mask the lower half of the body and spray black paint across the top.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Superglue an eye (available at hobby shops) on each side of the front. Once set, spray the lure with lacquer.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("7.")]), _vm._v(" Add a split ring to the front and a sharp treble hook to the rear.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t8"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_vm._v("9 MAKE YOUR OWN TROUT SPINNERS")])])]), _c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s easy to make your own in-line spinners that look as good as the name brands. Here’s how to do it—and save money in the process.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Start with a 6-inch length of .023-inch stainless-steel wire for a trout-size lure. (Larger spinners for pike or bass require thicker wire.) Use round-nose pliers to make a round, open loop with a tag end 2 inches long. Slide a dressed or plain treble hook into the loop.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Now add the extras. The components for one home-brewed spinner cost maybe 50 cents. Slip the first body component—a brass bead in this case—over both the tag end and the main wire. Then bend the tag end at a right angle above the bead and trim. This locks both the bead and hook in place.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Add remaining components and—in the case of a Mepps-style lure—a spinner blade mounted on a free-spinning clevis. Make sure no rough edges will impede the blade’s motion. Use the pliers to form another round loop at the top of the lure. Finish with two or three wraps of wire at the base of that upper loop.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25d.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t9"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_vm._v("10 CATCH BIG BASS WITH BUNNY FUR")])])]), _c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pork rinds and curly-tailed grubs are excellent trailers for jigs and spinnerbaits, but when pro angler Dave Wolak needs to up his game, he steals a page from the flyfisherman’s book and hooks on a bunny strip. “The fluttering action looks just like a mouse tail,” he says. The pennant of rabbit skin, typically used on streamer patterns, also won’t come off easily.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t10"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_vm._v("11 RIG ME SOFTLY")])])]), _c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("These four rigging methods will get any style of soft-plastic lure ready for action.")]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("WACKY RIG")]), _vm._v(" (A) This killer setup for bass involves hooking slim soft-plastic bait through the middle. Both ends are left free to wiggle, and in most cases no weight is added. It’s especially effective with Senkos.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TUBE RIG")]), _vm._v(" (B) There are several good ways to rig tubes such as the Gitzit. Most often I go with a small internal jighead. For a 3½-inch tube, use a 2/0 3/8-ounce, insider-style jighead. Insert the hook in the tube’s head and rotate it so it passes down inside the body without exiting. Continue by forcing the head of the jig into the tube, leaving only the hook eye exposed. Then work the hook point out and through the tube at the rear so the tube lies straight.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CAROLINA RIG")]), _vm._v(" (C) To make this common rig for bottom dredging, Texas-rig a worm or lizard but leave the hook eye exposed. Tie 18 inches of clear leader between the hook and a small barrel swivel. On your main line, thread a brass Carolina weight (or lead sinker), followed by a small red glass bead, and tie your main line to the other side of the swivel. The weight will click against the glass bead as you fish to help attract bass.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TEXAS RIG")]), _vm._v(" (D) Most often used with plastic worms and lizards, this rig is adaptable to other baits, like jerkbaits. Put a conical worm weight on the line first and then attach the hook. Thread the hook point about ½ inch into the worm’s head and then through the worm’s underside. Slide the worm up the hook shank so it just covers the hook eye. Rotate the hook until it faces upward toward the worm’s body. Grab the worm right behind the hook bend, push its body slightly forward, and then bring it back down on the hook point until the point is almost but not quite all the way through the plastic. The bait should now lie straight. I use a 3/0 Gamakatsu offset-shank worm hook for a typical 6- or 7-inch worm, but any similar style is fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t11"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t12"
    }
  }, [_vm._v("12 MAKE SPOOKS SPOOKIER")])])]), _c('a', {
    attrs: {
      "id": "t12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Heddon Zara Spook, a stogie-shaped, dog-walking stickbait, has been duping bass for more than 70 years. Heddon offers several versions, but the 5-inch, ⅞-ounce Super Spook is the favorite of legendary pro bass angler Penny Berryman. Berryman performs several modifications that turn her Super Spook into a “Superb” Spook, and it would take a Brink’s truck to haul all the money Berryman has won with this lure. Her tweaked lure is 4⅜ inches long and weighs about ¾ ounce—almost the size of the original Zara Spook. However, her Superb Spook is stouter, and it presents a better profile and splashes more when walked across the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Remove the hooks. Mark off a ⅝-inch-wide section of the lure around the middle hook hanger. The mark on the nose side should be ¼ inch from the split-ring hanger. Saw off the marked section. Save the split ring and put it on the line eye to give the bait freedom to sashay.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Place two small ball bearings, six BBs, or two 8-mm glass beads inside the lure. They’ll rattle and make the lure’s tail sit deeper for better hookups. Apply a coat of 5-minute epoxy with a toothpick to the sawed openings on each half of the lure. Let the epoxy set.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Shave off the excess epoxy with a razor. Smooth the joint with 220-grit sandpaper and finish with a buffing compound. Replace the hooks with longer-shaft Gamakatsu hooks. A red front treble reduces short strikes by encouraging bass to attack the head of the bait.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t12"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t13"
    }
  }, [_vm._v("13 USE AN IRRESISTIBLE JIG")])])]), _c('a', {
    attrs: {
      "id": "t13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Summertime bass love to hang out on deep humps, ledges, and dropoffs covered with gravel, rocks, or shell beds. This is true whether you’re after spots, largemouths, or smallies in a reservoir or a natural lake. This type of hard, snaggy bottom eats regular jigs like potato chips, but a wide football-head jig scurries over this bottom structure easily. Even better, a football jig appeals to the biggest bass in school.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("HEADS AND TAILS")]), _vm._v(" A ½- or ¾-ounce skirted football jig grinds on the bottom. This attracts bass and goads strikes. And you feel every pebble. Dress the jig with a 4-inch twin curly-tail or plastic craw. Go with black-and-blue in stained water and green pumpkin in clear water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TOUCH DOWN")]), _vm._v(" Cast a football jig with a 7-foot medium-heavy baitcasting outfit matched with 14-pound fluorocarbon line. The long, stiff rod takes up slack on the hookset, and the low-stretch fluorocarbon sinks, helping the jig maintain bottom contact for more solid hookups.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("INTERCEPTION")]), _vm._v(" Drag the jig slowly over the bottom by pulling the rod sideways to roll the hook and trailer up, making the bait a perfect imitation of a fleeing crawdad. You should feel the jig tickling a hard washboard bottom. When that sensation changes to a steady weight, set the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t13"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_vm._v("14 SOFT-SELL A MUSKIE")])])]), _c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Traditional crankbaits and spinners are still the best search lures for locating widely dispersed, pressured muskies on still waters. But too often, even with the best lures, the fish only want to look. They’ll follow, but then they are likely to turn away. The solution is to have a second rod rigged and handy. If you follow up with a big 8- to 10-inch soft-plastic bait, you’ll often get them to take it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SOFTEN UP")]), _vm._v(" Soft-plastic baits have several benefits. First, many muskies have not seen them before. Second, they can be fished vertically to already located fish. Third, muskies are more likely to hold on to these soft, squishy baits long enough for you to set the hook. Insider favorites include Reaper Tails, Monster Tubes, and giant Slug-Gos, each rigged on a ½- to 1-ounce jighead.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FLIP OUT")]), _vm._v(" If a muskie follows but doesn’t take your search lure, quickly flip the soft bait to where you last saw the fish. Then let the lure plummet to the bottom. A lot of muskies will hit it on the fall. If not, yank it up and let it fall again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BE VERSATILE")]), _vm._v(" Soft plastics are excellent baits for flat water with little structure, and they can also be used to search for muskies on bars and shoals known to hold fish, as well as on flowages with lots of likely cover.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t14"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_vm._v("15 GIVE NEW LIFE TO OLD BASS LURES")])])]), _c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every bass angler owns a magical plug or crankbait that catches fish when others can’t. It’s critical that you take extra care of these MVPs to keep them from losing their mojo. Tennessee bass pro Craig Powers has been duping bass for decades with his “antique” P70 Rebel Pop-Rs; his “bass body shop” restores about 2,000 lures a year. Here’s how Powers says you can keep your lures from needing an overhaul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STOP RUST BEFORE IT STARTS")]), _vm._v(" Corroded split rings are a major reason you end up with rusty hooks and discolored finishes. Powers replaces factory split rings with noncorrosive stainless-steel split rings. He also stores his prize baits in flat utility boxes to keep them from banging against one another, which chips the finish. Line the bottom of each slot with a piece of ½-inch-thick hard craft foam for added protection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FRESHEN UP")]), _vm._v(" Remove rust stains and restore dull finishes by polishing baits with ketchup.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t15"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t16"
    }
  }, [_vm._v("16 FISH THE TOP 10 FRESHWATER BAITS")])])]), _c('a', {
    attrs: {
      "id": "t16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not sure what to buy at the tackle shop? You can’t go wrong with one of these top producers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("1. NIGHTCRAWLERS")]), _vm._v(" Whether you dig your own or pick up a container at the tackle shop, nightcrawlers are arguably the most universal bait used in freshwater.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("2. CRAYFISH")]), _vm._v(" These freshwater crustaceans, best fished in rocky areas, are candy to bass, walleyes, and perch. You can use a whole live crayfish or just the tail meat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("3. FATHEAD MINNOWS")]), _vm._v(" These small, relatively inexpensive baitfish can be fished by themselves on a plain hook or on lead jighead for deeper presentations, as in ice fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("4. LEECHES")]), _vm._v(" Their dark color stands out in the water, and their wiggle is hard for fish to resist. They’ll catch everything from perch to smallmouths but are best known as the premier live bait for walleyes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("5. GIZZARD SHAD")]), _vm._v(" A live adult gizzard shad makes an excellent bait for trophy freshwater striped bass, pike, muskies, and even blue and flathead catfish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("6. SALMON EGGS")]), _vm._v(" Although these salmon eggs won’t catch a wide variety of species, if you’re after members of the trout family, they are quite tempting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("7. MEALWORMS")]), _vm._v(" Available in orange and red colorations, these beetle larvae have an armor-like exterior that makes them hearty, and their bright color helps them stand out in the water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("8. WAXWORMS")]), _vm._v(" The caterpillar larvae of wax moths, waxworms are very tiny but very potent. They’ll catch trout anywhere they live, but “waxies” shine as panfish baits.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("9. CRICKETS")]), _vm._v(" Crickets are delicate and don’t live long on the hook, but then it doesn’t take long for a bluegill, trout, or crappie to slurp one up. Find them at a bait or pet shop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("10. SHINERS")]), _vm._v(" “Shiner” is used to refer to any silver- or gold-scaled baitfish species. Use large golden shiners for largemouth bass or pike, smaller ones for trout, crappies, and smallies.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t16"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_vm._v("17 HARVEST NATURE’S BAIT BOUNTY")])])]), _c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have a shovel and a lawn, you’ve got all the worms you need. But that’s not the only productive bait around. The creek you fish can supply its own—for free. (Just be sure to check bait-collection regulations in your area before heading out.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Good bait shops carry some of these critters, but expect to pay at least $17 for a dozen hellgrammites, $5 for 12 shiners, and $3 a pound for crayfish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("HELLGRAMMITES")]), _vm._v(" Most fish love these nasty aquatic larvae. Pick them off the bottom of submerged rocks by hand, or stretch a seine across a fast-water section of the creek and flip rocks upstream. The current will flush the bugs into the net.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MINNOWS")]), _vm._v(" They’re easier to catch off the main current, so approach from midstream with a seine and corral the school against the bank as the net closes. If the bait is thick and the water fairly shallow, a quick swipe with a long-handled dip net will work too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CRAYFISH")]), _vm._v(" Find a stretch of slow-to-moderate current, then flip rocks and scoop up crayfish with a dip net. You can also stretch a seine across the creek and walk downstream to it while splashing and kicking rocks to spook crayfish into the mesh.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALAMANDERS")]), _vm._v(" Often overlooked, this bait is like catnip to bass and big trout. Look for them under larger rocks near the water’s edge. Good rocks are often dry on top but cool and moist underneath. Moss-covered rocks farther up the bank are also good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GRUBS")]), _vm._v(" Find rotten logs or wood near a creek bed. Peel away the bark to expose the soft, dead wood, or dig in the dirt underneath, and you’ll likely find some fat white grubs. Finding a trout or crappie that won’t eat them? Impossible!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GRASSHOPPERS")]), _vm._v(" The best way to catch hoppers is to walk through the tall grass that often flanks a stream with a cheap butterfly net. Just skim the net across the tips of the blades; you’ll have a dozen or more hoppers in a flash.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t17"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t18"
    }
  }, [_vm._v("18 BUZZ A WORM")])])]), _c('a', {
    attrs: {
      "id": "t18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("With two conductive rods, jumper cables, and a car battery, you can make nightcrawlers come crawling to you in no time. An entomologist we asked about this trick figured that the electricity hyperstimulates the worm’s nervous system, causing its muscles to become hyperexcited and send the worm fleeing to the surface. Here’s how to jump-start your day of fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Find a patch of soft earth and hammer rebar or copper rods about 8 to 10 inches into the ground and 2½ to 3 feet apart. Then clamp one end of the jumper cables to each rod.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Wearing rubber gloves, extend the cables as far from the rods as they’ll go. Attach the cables to the battery. Do not go near the rods while they’re hot.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" The payoff comes fast—in a minute or even less. Once you see worms surfacing, disconnect the cables from the battery and then from the rods. Gather bait and get fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t18"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t19"
    }
  }, [_vm._v("19 BECOME A WORM FARMER")])])]), _c('a', {
    attrs: {
      "id": "t19"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Worms catch more fish than any other bait, but they are often difficult to find just when you need them most. If you plan on doing a lot of plunking this season, you may want to consider propagating your own steady supply of wigglers by setting up a worm farm. All it takes is a little know-how and a proper storage container.")]), _vm._v(" "), _c('div', {
    staticClass: "boxc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MATERIALS")]), _vm._v(" Opaque 10-gallon plastic storage tub with a tight-fitting lid • Watercooler-style plastic spigot (available at hardware stores) or wine cork • Sheet of mesh screening to fit tub interior • Shredded paper and plain cardboard (nothing glossy) • Dead leaves • Wood chips • Gravel • Fine sand or ground eggshells • 1 pound bait-shop red wigglers (about 750 worms) or European nightcrawlers (about 300).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Drill two parallel rows of 1/8-inch holes lengthwise across the lid and one row around the sides of the box a few inches below the top to allow air to circulate and moisture to disperse. Holes should be spaced 1 inch apart.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Install the plastic spigot alongside a bottom corner of the tub per the manufacturer’s instructions. Or drill or cut a ¾-inch hole and plug it with a cork. This will be used to periodically drain the fluid that accumulates as a result of the worms’ composting activity.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Cover the bottom of the tub with an inch or two of river-run gravel and top that with a layer of mesh. Fill it two-thirds full with damp shredded paper and cardboard mixed with dead leaves, two handfuls of wood chips, and two handfuls of sand or eggshells.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Spread the worms in the tub and cover with more damp bedding. Replace the lid and put the tub in a vibration-free spot where the temperature can be maintained between 50 and 75 degrees F.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 5")]), _vm._v(" Wait one week and then add a pound of mixed chopped vegetable scraps, fruit rinds, coffee grounds, used tea bags, and/or rotting leaves (no meat or animal products). Bury this mixture along with a handful of cornmeal beneath a few inches of the bedding whenever the previous supply disappears, about once a week. Add shredded paper and leaves as bedding is depleted, and sprinkle the surface with enough water to keep the bedding damp but not wet. If properly maintained, the farm should supply you with bait indefinitely.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t19"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t20"
    }
  }, [_vm._v("20 LET SOME LIVIES LOOSE")])])]), _c('a', {
    attrs: {
      "id": "t20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When chumming with live baitfish in saltwater, hold them out of the water for a minute or two before throwing them in. The disoriented fish will be easy prey. Once gamefish begin feeding on the easy-to-catch bait, they will eagerly hit similar flies, lures, or a baited hook cast into the same area. Make sure you use only native bait trapped from the water you plan to fish.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t20"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_vm._v("21 SCORE MINNOWS WITH BUBBLE GUM")])])]), _c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of baiting minnow traps with bread, cornmeal, or cat food, try using a fresh stick of chewing gum. Though minnows and shiners will swarm to the gum, they won’t eat it. And since it doesn’t dissolve, a single piece will effectively bait the trap for several days. It is by far the most effective and cleanest bait.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t21"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t22"
    }
  }, [_vm._v("22 THROW CHUM A LONG WAY")])])]), _c('a', {
    attrs: {
      "id": "t22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tossing live baitfish or ground chum into your targeted area before beginning to cast is a sure way to start a feeding frenzy. To throw chum farther with less arm strain, make a bait-hurler. Cut the bottom out of a sturdy plastic gallon jug. Insert a 3-foot broom handle into the jug’s neck, drill two holes through the neck and handle, and fasten them together with bolts and washers. Load it up with chum and toss.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35e.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t22"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_vm._v("23 CATCH BIG FISH WITH BIG LURES")])])]), _c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("By August, live-bait species have grown in size, and gamefish focus on bigger prey than what attracted them earlier in spring and summer. Start using large streamer flies, spoons, lures, and live baits, and make slower retrieves. Fish in the shallows during hours when boat traffic is at a minimum and the sun is off the water. During midday, most gamefish suspend in deep water over rocky humps, sunken trees, and deeper channels.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t23"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t24"
    }
  }, [_vm._v("24 MAKE YOUR OWN CATFISH CANDY")])])]), _c('a', {
    attrs: {
      "id": "t24"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Spend a morning catching some carp, quillbacks, or suckers. Small fish (weighing up to 3 pounds) are best. Scale the fish, leaving the skin on, then cut the fillets into 1-inch- square chunks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Fill a jar two-thirds full of the fish chunks, and add either a premade flavored jelly or a mixture of cod liver oil and powdered garlic. Shake gently, and refrigerate. That’s all you need—you can fish this bait right out of the jar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Spear the baits on a No. 1 circle hook tied to an 18-inch mono leader below a barrel swivel, plastic bead, and ½-ounce bank sinker. Cast to the edge of logjams and holes, and let the scent go to work.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t24"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_vm._v("25 GO DARK AND DEEP")])])]), _c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When smallmouths scatter along rocks and weeds in their post-spawn funk, try turning to the seductive synergy of a jig-and-crawler combination. You can fish deep and cover a lot of territory, and the crawler seems to be the perfect touch for this transitional time, when the smallmouths have yet to lock on to a preferred forage. Dark jigs—black, brown, and purple—seem to match the nightcrawler’s color. Try using a whole crawler and jig with a marabou feather skirt. When you get hit, drop the rod for 2 or 3 seconds before setting.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t25"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_vm._v("26 MAKE A DOUBLE-SIDED WORM CAN")])])]), _c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of digging down to the bottom of a coffee can to find worms, replace the metal end of the can with another plastic lid in which you’ve punched a dozen tiny airholes. When the worms burrow down to the bottom, simply turn the can over and open the other end.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t26"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t27"
    }
  }, [_vm._v("27 SWEEP FOR ’EYES")])])]), _c('a', {
    attrs: {
      "id": "t27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Walleyes take a wide variety of worm rigs across their range. Whether you slowly troll or drift with the current or wind, one thing’s for certain: The sinker had better be rapping the bottom. And distinguishing bottom from a bite can be tough. The trick is to ease the rod back to the strike (maybe a foot) and feel for life at the end of the tightening line. If it’s there, set the hook with a sweep rather than a jerk. Once in a while you’ll find yourself hooked to those slow, hearty tugs and that lovely weight of spring.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t27"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t28"
    }
  }, [_vm._v("28 PICK THE BEST REEL FOR THE JOB")])])]), _c('a', {
    attrs: {
      "id": "t28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Anglers love to debate spinning vs. baitcasting reels. But really, it’s less a matter of one being better than it is that spinning and baitcasting are two very different things. Spinning in freshwater usually means lighter line and lighter lures—usually 12-pound-test or less. Baitcasting is typically done with heavier line and lures. The experienced angler uses both, depending on the circumstances. Going for a big brute of a muskie? Baitcasting is probably your best bet. Jigging for perch in a river? Try a spinning outfit.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BAITCASTING REEL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The spool on a baitcasting reel revolves on an axle as it pays out line. By applying thumb pressure to the revolving spool, an angler can slow and stop a cast with pinpoint precision. Baitcasting reels require skill and practice and are a favorite of bass anglers, many of whom insist the reels afford more sensitive contact with the line than spinning reels. Baitcasters get the nod from trolling fishermen, too, for the revolving spool makes it easy to pay out and take up line behind a boat and also reduces line twist.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SPINNING REEL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spinning reels have fixed spools that do not rotate—the line uncoils from the front of the spool, pulled by the weight of the lure. Since the cast lure doesn’t need to have enough force to spin a rotating spool, spinning reels can utilize very light lures—ultralight spinning reels can handle lures as feathery as 1/32 of an ounce—and backlash is rarely an issue. The downside to spinning reels: Stopping a cast isn’t a straightforward task. And spinning reels are notorious for twisting line. It’s best to pump the rod up and reel on the way down to minimize twist.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40-41.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t28"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t29"
    }
  }, [_vm._v("29 GET SOME GUIDANCE")])])]), _c('a', {
    attrs: {
      "id": "t29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("All fishing rods start out as a blank. Some are weighted and tapered for making fly rods, while others are designed to serve as the base for big-game saltwater rods that can battle a marlin. What really make a rod function properly are the guides. Understand how guides work, and you’ll understand why different rod styles are better suited to varying fishing situations. These four guide styles and configurations are the ones you’re most often going to find in your local tackle shop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CONVENTIONAL ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Conventional and bait-casting reels sit on the top side of the rod, and reel line straight onto a narrow spool. They're not as wide as spinning reel guides, and generally taper very quickly to a small-diameter tip guide. Line comes off of these reels very quickly, so it’s important that it stays channeled to achieve maximum accuracy and distance. Some companies now make conventional rods with super-tiny “micro guides” all along the blank. It’s believed that the smaller the guides, the more accurate the cast, especially when used with the ultra-thin braided lines and super lines popular today. The small diameter and fast taper of conventional guides also aid in accuracy in short, delicate presentations with methods like flipping, which are much harder to achieve with a spinning rod.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FLY ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the exception of the first guide on a fly rod—which is wider and thicker and known as the stripping guide—fly rods are built with light, thin-wire guides, often called “snake guides.” Since the reel never comes into play in terms of cast distance or accuracy, snake guides are designed to simply let the fly line pass through freely and without obstruction while adding as little weight to the rod as possible. To that end, it’s important to always make sure snake guides are aligned properly and don’t have any grit or residue buildup on the inside. You want the guides to remain as smooth as possible to maximize your casting distance and accuracy. The stripping guide is wider and beefier because it takes the most strain when stripping streamer flies. You’ll often find two stripping guides on heavier fly rods used for saltwater fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BIG-GAME ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Uniquely designed for the rods that stand up to tuna, marlin, and swordfish, roller guides have heavy-duty metal frames and feature one or two smooth wheels on bearings that turn freely within the frame. Big-game rods with roller guides are not meant to be cast, but are almost exclusively used for trolling. The bearings up the chances that the thick-diameter monofilament line typically used for big-game pursuits won’t catch or snag in the heat of the moment, but, more important, they assure that line flows through the guides as smoothly as possible when a fish grabs a lure on the troll and starts peeling drag. Some rods designed for jigging may feature a roller guide at the tip or as the first guide closest to the reel, but if you’re looking for versatility in a saltwater rod, you’ll likely want to skip the rollers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SPINNING ROD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spinning rod guides taper more drastically than those on any other rod. Because spinning reels have wider spools and retrieve line in wide loops, the first guide closest to the reel is often referred to as the gathering guide. This guide is the widest in diameter on the rod, which both allows line being retrieved to wind on the spool evenly and doesn’t constrict line coming off the reel during the cast. This helps achieve smoother, longer casts. Make sure your spinning reel is the proper size for the rod you’re using. If it’s too big, the gathering guide may not be wide enough to wind the line properly, causing loops and tangles in your spool. Many anglers prefer spinning rods with 7 to 8 guides or more, because the more guides, the greater the taper as the line passes through, and the more accurate the cast.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t29"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_vm._v("30 FISH TO LIVE")])])]), _c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Survival fishing isn’t as simple as the manuals suggest. That doesn’t mean you shouldn’t carry a survival fishing kit, but the emphasis should be on gear that fishes while you rest. First choice is a trotline, which consists of a series of hooks attached by short leaders to a main line, which is easier to handle than monofilament. Attach leaders to the main line with swivels, string them one at a time, and use overhand knots as stoppers to keep the leaders spaced. Tie one end of the main line to a branch and weight the submerged end with a rock. Hide the hooks hooks in any natural baits you can find. Salmon eggs work really well if you can get them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You’ll also want a treble hook, which can be bent and then lashed to a stick with snare wire to make a gig or gaff. The wire also can be bent into small loops to make rod guides and wrapped at intervals along a willow switch or another limber stick. You’ll find that it is much easier to fish with a cork and worm—or even to cast flies—if your rod is equipped with guides so that you can control the line with your hand.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t30"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t31"
    }
  }, [_vm._v("31 PERFORM EMERGENCY GUIDE REPAIRS")])])]), _c('a', {
    attrs: {
      "id": "t31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A broken guide shouldn’t be the end of a perfectly fine rod, or a great fishing trip. For strength, durability, and speed, nothing beats a strip of shrink-wrap to attach a new guide. In the fall, local marinas or boatyards have scraps from winterizing that you can pick up for free, and you can buy an assortment of guides at local tackle shops. Make a repair kit and keep it in your boat.")]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Cut a triangular piece of shrink-wrap long enough to wrap three times around your rod. The width of the base should extend beyond the foot of the guide.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Cut off the threads and foot of the broken guide with a razor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Select an appropriate-size replacement.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Tape the new guide to the rod blank.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 5")]), _vm._v(" Wrap one foot with shrink-wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 6")]), _vm._v(" Heat with a lighter, but be careful not to get the flame too close or you risk melting the shrink wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 7")]), _vm._v(" Repeat steps 1 through 6 on the second guide foot.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42b.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t31"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t32"
    }
  }, [_vm._v("32 LET THE ROD DO THE WORK")])])]), _c('a', {
    attrs: {
      "id": "t32"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spinfishermen and baitcasters can throw a line with greater distance and accuracy by leaving half a rod’s length of line hanging from the rod tip when casting. This extra length causes the rod tip to flex deeper when the cast is made, generating more power from the rod with less effort from the wrist and arm. The reduced physical exertion permits better hand-eye coordination.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t32"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_vm._v("33 HAVE A CANE-DO ATTITUDE")])])]), _c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You could use one of those fancy side-scan sonar depthfinders with the new underwater fish-eye orthographic readouts. Or you could go cut a switch of bamboo and do a little cane-pole fishing. If you choose the latter, a decent cane pole is as close as the nearest stand of bamboo. Ordinary backyard bamboo works just fine for panfish, bass, and small catfish. Make a cane pole our way, with the line anchored to the pole along its entire length, and you’ll be able to land anything that doesn’t pull you into the pond first.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Cut a straight piece of cane about 10 feet long. Trim the leaf stems as close as possible. Saw through the fat end at the bottom of a joint so the butt end will have a closed cap. Smooth the rough edges with sandpaper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Tie a string to the slender tip and suspend the cane as it dries to a tan color. (This could take several weeks.) Straighten out a curved pole by weighting it with a brick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Using an arbor knot, attach 20-pound line a few inches above the place where you’ll want to hold the rod. Lay the line along the length of the pole and whip-finish the running line to the rod with old fly line at two spots—a few feet apart—in the middle of the rod and at the tip. (You’re doing this so that, if the rod tip breaks, the line will remain attached to the pole.) Attach a 2-foot monofilament leader. Total length of the line from the tip of the rod should be about 14 to 16 feet. Finish with a slip bobber, split shot, and a long-shank hook for easy removal.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t33"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_vm._v("34")])]), _c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_vm._v(" KNOW YOUR: "), _c('b', [_vm._v("BLUEGILL")])])]), _c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most anglers cut their teeth as kids chasing these easy-to-catch scrappers at the neighborhood pond or creek. Bluegills will eat anything from a fresh, lively cricket to a ball of stale white bread on a hook. Don’t want to use bait? Any little fly, small spinner, soft-plastic grub jig, or tiny crankbait will do. But these aggressive fish aren’t all child’s play; serious grown-up anglers invest a lot of time hunting the biggest of the big in lakes and reservoirs across the country, as bluegills can break 2 pounds and are excellent on the table. The current world-record bluegill weighed in at an amazing 4 pounds, 12 ounces. If it’s jumbo fish you’re after, start a search around weedbeds, humps, and brush piles in 5 to 10 feet of water. If you just want to catch a whole mess and don’t care about size, find the local public dock, cast a worm under a bobber, and start having fun.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t34"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t35"
    }
  }, [_vm._v("35 PUT ON THE BRAKES")])])]), _c('a', {
    attrs: {
      "id": "t35"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When it comes to setting the drag, lots of fishermen don’t have a clue. The general rule for monofilament lines is that your drag setting should be about one-third of your line’s breaking strength. Say you’re fishing with 12-pound-test mono. That means you should tighten your reel’s drag until it takes 4 pounds of force to take line from the reel. You can play with a drag knob and tug on the line while guessing at the setting, but it’s far better to actually measure it. Try a simple 20-pound spring scale hooked to a line loop at the reel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are times when you need a tighter drag setting, but that applies only to comparatively heavy tackle. Some hardcore bass anglers lock down their drags when fishing thick cover—both to get a solid hookset and to haul big fish out of the weeds. In testing different freshwater baitcasting reels by tightening the star-drag knobs as hard as possible by hand, I found that they actually don’t lock down at all. I could pull line from the reel in most cases with 8 to 10 pounds of force. With lighter lines, you’ll need to back off the drag a bit or risk disaster. Also, be sure to set your drag based not on the line strength alone, but on the weakest link between the reel and your lure or bait, such as a knot.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t35"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_vm._v("36 UNRAVEL BACKLASHED LINE")])])]), _c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make an excellent tool for unraveling backlashes from a No. 2 fishing hook. Using pliers, straighten the hook and flatten the barb. Then use a file to dull the point slightly. Push the eye of the hook deep into a wine cork and glue it in place. Use this cork-handled tool to pick loops of line out of the tangle until it clears.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t36"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_vm._v("37 FEATHER A SPINNING REEL 50 FEET")])])]), _c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("An open-face spinning reel may not have a baitcaster’s reputation for minute-of-angle accuracy, but you can still cast lures into tight spots from a decent distance with these popular rigs. The secret is to feather the outgoing line against the lip of the spool, much as you slow the revolution of a baitcasting spool with your thumb. It feels a little goofy at first, especially since you have to cast with both hands on the reel. But then you get used to the technique, and you start dropping lures into lily-pad openings the size of a cheeseburger bun, and you’ll remember that disentangling your spinnerbaits from low bushes felt a lot goofier. Here’s the drill for right-handed casters:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("WIND UP")]), _vm._v(" Start with the reel handle pointing up (A).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BAIL OUT")]), _vm._v(" Place your left hand under the handle and cup the spool in your palm (B). Open the bail with your left thumb or the fingers of your right hand. With your left hand, reach around the bottom of the spool, and extend your left index finger.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("HOLD THE LINE")]), _vm._v(" Trap the outgoing line against the spool rim with the tip of your left index finger (C). Now comes the goofy part: Make a standard cast while keeping the outgoing line pressed against the spool rim. Your left hand will travel with the spinning reel. Hold the line with your left index finger.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CONTROL THE CAST")]), _vm._v(" Release the line to send the lure toward the target. Use slight finger pressure against the spool lip to slow the line (D) and then stop the lure at the precise moment when your lure is in the zone you want to hit.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t37"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t38"
    }
  }, [_vm._v("38 OVERHAUL YOUR REEL IN 15 MINUTES")])])]), _c('a', {
    attrs: {
      "id": "t38"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Think of your reel like your car’s engine. Run it hard year after year without proper maintenance, and it won’t be long before it seizes. This quick procedure is like an oil change for your baitcaster or spinning reel. Do it before the season, and you’ll crank in fish all summer long.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Remove your old line (even if it’s new) and recycle it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Unscrew the drag cap and remove the spool. Then take off the handle cap and unscrew the winding handle in a clockwise direction. Lay the parts out on a clean work space in the same order in which you have dismantled them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Rinse the entire reel with hot water to remove any sand or grit. Once it’s completely dry, spray a nonflammable solvent (gun solvents work well) on metal parts to remove the dirty grease and oil. Let it dry and then wipe the reel with a clean cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Put one drop of oil in all holes, the shaft, and exposed bearings. Then dab threaded surfaces and gears with grease. Only apply reel-approved products. Don’t use WD-40, which leaves a hard-to-remove finish when heated. Less is best with oil and grease. Extra lubricant can slow the reel down. Reassemble, spool new line, and go fish.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t38"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_vm._v("39 CHOOSE THE RIGHT LINE")])])]), _c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("LONGEVITY")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deteriorates in UV light (sunlight)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindentg"
  }, [_vm._v("Not affected by UV")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fluorocarbon lasts longer")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("WATER ABSORPTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Absorbs water and weakens slightly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Does not absorb water")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fluorocarbon is stronger when wet")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("DENSITY")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Close to that of water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("About 60% denser than nylon; sinks readily")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nylon can be made to float or sink in fishing")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("COLD WEATHER")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Becomes stiffer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unaffected by temperature extremes")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fluorocarbon is a good ice-fishing line")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("KNOT STRENGTH")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moderate to high")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moderate to high")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A draw; depends on knot type")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ABRASION RESISTANCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moderate to low")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("High")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fluorocarbon is best in heavy cover")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("CHARACTERISTIC")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("PRICE")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("NYLON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Low to moderate")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("VS")])]), _vm._v(" "), _c('div', {
    staticClass: "boxj"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLUOROCARBON")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("High")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxe"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nylon is more affordable")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t39"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t40"
    }
  }, [_vm._v("40 LEAD THE WAY")])])]), _c('a', {
    attrs: {
      "id": "t40"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In most circumstances, clear fluorocarbon line is less visible to fish than nylon monofilament of the same size. (It is not completely invisible underwater despite what you might have heard.) If you’re after leader-shy fish such as winter steelhead in low, clear water or sharp-eyed false albacore in the salt, using fluorocarbon line makes perfect sense. Some kind of low-visibility fluorocarbon leader is also a good idea for trout, bass, and other fish made wary by fishing pressure. Abrasion resistance is also a huge plus. When these lines get nicked or scratched from being dragged across structure by a heavy fish, they are much less likely to break than comparable nylons. You have lots of knot options for making leaders. I usually use a four-turn surgeon’s knot to attach a fluorocarbon flyfishing tippet, for example, and back-to-back Uni knots with heavier lines.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t40"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_vm._v("41 MATCH YOUR FLUOROCARBON TO YOUR FISH")])])]), _c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’re fishing for largemouths in thick cover or stripers around underwater rocks, a fluorocarbon leader will fend off abrasion. When I’m nymphing for trout, I often add 3 feet of 5X or 6X fluorocarbon tippet to a standard tapered-nylon leader. The nylon butt stays at or near the surface to make control of the drifting fly easier, while the fluorocarbon tippet sinks readily with the nymph and is less evident to fussy trout. I don’t use fluoro tippet to fish dries because it will sink and pull the fly underwater. For bass and walleye fishing with spinning or baitcasting gear, I like superbraid lines because of the acute sensitivity their low stretch affords. All superbraids are opaque and require the addition of a clear leader, for which fluorocarbon is almost perfect. Attaching 3 feet of 12- to 20-pound clear fluorocarbon to 50-pound superbraid gives me a more abrasion-resistant leader that fish will have a tough time seeing. The only flaw in the equation comes when I am working surface lures, for which fast-sinking fluoro is a disaster.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t41"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_vm._v("42 TIE A PALOMAR KNOT")])])]), _c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the most widely useful—and the easiest—of all terminal knots used in freshwater and inshore saltwater fishing. It works well with both nylon monofilaments and superbraids.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Extend about 6 inches of doubled line through the eye of the hook or lure.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Tie a loose overhand knot using the doubled line on either side of the eye. The hook itself will hang from the middle of the knot.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Pass the loop over the hook. Wet the knot with saliva and then pull on the doubled line (but not the loop) to tighten. Trim closely.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t42"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_vm._v("43 GET INTO HEAVY METAL")])])]), _c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BULLET SINKER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MODELS:")]), _vm._v(" Lead, brass, steel, or tungsten; painted, free-sliding, or self-pegging.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("USES:")]), _vm._v(" Casting or pitching Texas-rigged soft plastics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RIGGING:")]), _vm._v(" Run the line through the sinker’s pointed end and tie it to a worm hook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TIPS:")]), _vm._v(" Use the lightest sinker needed to maintain bottom contact or to penetrate cover. Let the sinker slide free for open water; peg it to the head of the bait amid thick cover.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("EGG SINKER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MODELS:")]), _vm._v(" Lead, steel, or bismuth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("USES:")]), _vm._v(" Carolina-rigging soft-plastic bass lures; drifting and bottom-fishing live bait for everything from trout to stripers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RIGGING:")]), _vm._v(" Run line through the sinker and tie it to a two-way swivel. Attach a leader and hook to the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TIPS:")]), _vm._v(" This allows a fish to run with the bait without feeling the weight. Over a snag-filled bottom, pinch a split shot on the line in place of the swivel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DROP SINKER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MODELS:")]), _vm._v(" Lead, steel, or tungsten; round, teardrop, or cylindrical.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("USES:")]), _vm._v(" Fishing small soft plastics in deep water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RIGGING:")]), _vm._v(" Tie a drop-shot hook to the line with a Palomar, leaving a long tag line to attach the sinker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TIPS:")]), _vm._v(" After the sinker touches down, gently pull the line taut without moving the sinker. Then drop the rod tip and let the lure free-fall slowly to the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("WALKING SINKER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MODELS:")]), _vm._v(" Lead or steel; Lindy-style or banana-shaped (bottom weighted).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("USES:")]), _vm._v(" Presenting live bait to walleyes. They’re either dragged over the bottom behind a drifting boat or trolled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RIGGING:")]), _vm._v(" Thread the line through a walking sinker and tie it to a swivel. To the other side, tie a 3- to 6-foot 6-pound-test leader with a live-bait hook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TIPS:")]), _vm._v(" Banana-type models are more resistant to snags.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PINCH-ON SINKER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MODELS:")]), _vm._v(" Lead or tin; round, clam, bullet, or elongated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("USES:")]), _vm._v(" Getting lures, flies, and bait deeper for trout, bass, catfish, and other species. They’re most often used in stream and river fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("RIGGING:")]), _vm._v(" Pinch the shot or sinker to the line above the hook or lure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TIPS:")]), _vm._v(" Pinch-on weights are best used for casting. Clam and bullet shapes are more snag resistant.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48e.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t43"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t44"
    }
  }, [_vm._v("44 CHANGE HOOKS FOR BETTER FISHING")])])]), _c('a', {
    attrs: {
      "id": "t44"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove those treble hooks from your lures and replace them with straight-shank hooks one size larger. Attach the single hook to the lure’s forward hook mount and leave the rear bare. Fish often hit lures headfirst, so you will get just as many hookups, and the release will be easier.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t44"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_vm._v("45 SHAKE YOUR HEAD")])])]), _c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why reinvent the jig? Because a few tweaks can start a craze that anglers swear catches more and bigger bass. Lengthen the shank to accommodate weedless rigging, turn the line-tie eye 90 degrees and move it forward, and you’ve got a basic shaky-head jig. The design allows a floating soft-plastic worm or crawfish to stand perpendicular to the bottom, where subtle rod shakes get it wiggling in place. The tactic isn’t new; it just never had a name. It does now: shaky-head fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t45"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_vm._v("46 ADJUST YOUR BOBBER TO THE FISH")])])]), _c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BLUEGILLS")]), _vm._v(" When bluegills are on or near spawning beds in early spring, set your bobber to fish shallow with only 2 or 3 feet of line, holding your bait a few inches off the bottom. Later in summer, when bigger bluegills have moved to offshore bottom humps 10 to 12 feet deep, slide your bobber stop up the line to fish the same terminal gear at those depths.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TROUT")]), _vm._v(" For both resident stream trout and steelhead, adapt the tactic to moving water. To work a run of moderate current that’s 4 feet deep, set your bobber so your worm, salmon egg, or small jig is just above the bottom as the bobber drifts with the current. Cast up and across the stream and then hold your rod high; keep as much slack line as possible out of the current to avoid drag on the bobber while following the drift with your rod. When the bobber pauses or darts underwater, set the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("WALLEYES")]), _vm._v(" Put a wriggly leech on a size 6 or 8 hook, add some small split shots, and set your slip bobber to fish at the same depth as the outside edge of a deep weedline. Ideally, a light breeze will drift both your boat and the floating bobber slowly along the edges of the vegetation, so you’ll be covering lots of water with very little effort.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BASS")]), _vm._v(" Set your slip bobber shallow to fish a frisky 3-inch live shiner along shoreline structure. When you come to some deeper structure off a shoreline point, it takes only a few seconds to adjust your bobber stop and fish the same shiner 10 feet deeper and right on the money.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t46"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_vm._v("47 PLAY THE BAITING GAME")])])]), _c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you’ve made the effort to catch fresh live bait (or buying it from a gas-station vending machine), having it constantly fall off the hook can lead to a short, aggravating day of fishing. Be sure to rig your bait on the correct hook style.")]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("BASICS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Turned-in point impales fish in the corner of the mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ring on this hook lets baitfish swim freely.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Encourages bites and penetrates easily.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49d.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two spikes on the shank of this worm dunker’s fave hold long bait in place.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49e.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The large gap and turned-in point lock larger bait in place and hold fast.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("BAITS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Live or dead baitfish and cutbait.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("All live baitfish, from fathead minnows to shiners and herring.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shiners hooked up through the lips or under the dorsal fin above the spine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49d.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Red worms for panfish; crawlers for walleyes, trout, and catfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49e.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crayfish, large shiners, and other live baitfish.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("PRESENTATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bottom rigs work with dead bait and cutbait. Use a free line for live baitfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any live-baitfish tactic, including bobbers, free lines, and bottom rigs.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a long pole, dip the Aberdeen hook and minnow combo in pools.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49d.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any bait fishing tactic that involves frisky live bait.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49e.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fish shiners under a bobber or on a free line.")])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t47"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t48"
    }
  }, [_vm._v("48 GAIN SOME WEIGHT")])])]), _c('a', {
    attrs: {
      "id": "t48"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The weight you choose to rig a soft-plastic bait can make that lure a killer—or a dud. Compared with yesterday’s sinkers, today’s models are more sophisticated and specialized than ever, so it pays to invest in a variety of them. Here are six types you need in your tackle box, so you can always sink to the bass’s level.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("1. BULLET WEIGHT")]), _vm._v(" Environmentally friendly tungsten bullet weights are smaller than equally heavy lead and louder when your Texas-rigged bait bumps cover.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("2. INTERNAL TUBE WEIGHT")]), _vm._v(" Compared with a bullet weight, this sinker gives tubes a more natural appearance and a smaller profile. For skittish bass, both advantages can pay.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("3. SPLIT SHOT")]), _vm._v(" Split-shot rigs are deadly for lure-shy bass. Bullet Weights Egg Shot slides over cover more easily than round split shot, reducing snags.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("4. WEIGHTED HOOK")]), _vm._v(" A weighted hook lets you alter a bait’s action.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("5. CAROLINA SINKER")]), _vm._v(" Noisy Carolina rigs usually work better. On Lindy’s Carolina Mag Weight, magnetized steel balls separate and collide with the slightest movement to draw more bass. The weight comes preassembled.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("6. DROP-SHOT WEIGHT")]), _vm._v(" Drop-shotting excels for finessing clear-water bass. They’re denser than lead and help you “feel” what’s on the bottom. The narrow, line-gripping eye eliminates the need for a knot.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t48"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t49"
    }
  }, [_vm._v("49 TIE A CLINCH KNOT")])])]), _c('a', {
    attrs: {
      "id": "t49"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This versatile terminal knot is excellent for securing your line to a hook, lure, or swivel; it’s perhaps most commonly used to fasten the leader to a fly.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50f.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Pass several inches of line through the hook or lure eye (1). Next, loosely wrap the tag end around the loop you've made (2). Wind the leader several times around the loop, then pass it through the opening just below the hook (3). Pass the leader through the far end of the loop (4), and then tighten down and trim as necessary (5). The hook itself will hang from the middle of the knot.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t49"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_vm._v("50 MAKE IT SNAPPY")])])]), _c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Snaps that hold lures are as important as the lures themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DUOLOCK SNAP")]), _vm._v(" Available in wide variety of sizes, duolock snaps open wide to easily slip through the eye of any lure. Just make sure you use one strong enough for the size fish you're targeting, because they can pull open if over-stressed.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("COASTLOCK SNAP")]), _vm._v(" Typically made of heavier-gauge wire than duolock snaps, Coastlocks are staples in the saltwater world when tuna, marlin, and other big-game species are involved. Their design makes them very hard for a hard-fighting fish to pull open.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CROSS-LOK SNAP")]), _vm._v(" Slighlty stronger than duolocks because of their design, cross-loks--even smaller models--can handle a lot of pressure. These snaps are often found on pre-made wire leaders for bluefish or muskies.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51c.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t50"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_vm._v("51 PROPERLY SHARPEN A FISHHOOK")])])]), _c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Have you sharpened any lure hooks lately? Has a fish pulled a split ring open on you in the last few years? If not, it’s probably because razor-edged hooks and superstrong split rings have become standard on many new lures. You’re going to do more harm than good by attempting to improve the new generation of chemically sharpened hooks, but less expensive versions normally need touch-ups. Here’s how to do it right.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Hold the hook you want to sharpen by the shank between your thumb and forefinger so that the bend faces inward and the point is away from you. Grasp a metal file in your other hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Brush the left side of the point away from you and down the file in one long stroke. Give it another stroke if you desire, but file any further and you’ll weaken the point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Repeat the first two steps for the right side and the outside of the point.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51d.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t51"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t52"
    }
  }, [_vm._v("52 RIG A SLIP BOBBER")])])]), _c('a', {
    attrs: {
      "id": "t52"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rigging a slip bobber is a breeze. First, fasten a bobber stop on your line. Some commercial ones are on string that comes pre-knotted around a tube. Thread your line through the tube and then slide the knot off the tube and tighten. Or try what I like best: a bit of rubber tubing so small that it impedes casting very little when wound on your reel. If your slip bobber has a large hole at the top, add a small plastic bead on your line to keep the stop from sticking inside the bobber. Thread on the bobber after the bead and then tie a hook to the end of your line with two or three small split-shot sinkers spaced a few inches apart a foot or so above the hook.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t52"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_vm._v("53 USE THE BEST TROUT FLY FOR THE JOB")])])]), _c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No one fly catches all the fish all the time. That’s a fact of flyfishing, and it’s why there are thousands of different patterns. Fish, ever whimsical, sometimes refuse to eat on Friday the fly they ate on Tuesday. Fishermen, ever inventive, constantly create new patterns to compensate. Despite this, some standard patterns have evolved. Tested by time, water, and fish, these are the old reliable flies you need.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BLACK GHOST")]), _vm._v(" This classic Maine-born streamer is killer for trout holding in fast water.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("EGG FLY")]), _vm._v(" Not a fly so much as a ball of yarn, salmon egg patterns hook everything from stocked trout to native steelhead.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("HARE’S EAR NYMPH")]), _vm._v(" Weighted or unweighted, these match-all bugs fool trout in any water style.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("GRIFFITH’S GNAT")]), _vm._v(" When trout are eating super-tiny bugs, it's hard to beat this classic midge pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-5.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("DAVE’S HOPPER")]), _vm._v(" Most people are inclined to pick larger sizes to match big grasshoppers, but the smaller sizes may get you more strikes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-6.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ZONKER")]), _vm._v(" A formed lead-foil underbody acts acts as a keel, which serves to keep this sexy streamer upright when stripped and twitched.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-7.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BLUEWING OLIVE")]), _vm._v(" These little mayflies are ubiquitous on rivers nationwide, and hatch almost year round.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-8.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BEADHEAD PRINCE NYMPH")]), _vm._v(" Fish this generic nymph under an indicator in fast riffles and eddies. And hang on!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-9.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BLACK WOOLLY-BUGGER")]), _vm._v(" This universal streamer matches everything from leeches to baitfish and often produces when all else fails.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ELK HAIR CADDIS")]), _vm._v(" Simply the best caddis imitation you can find. I carry light and dark styles in sizes 12 to 20.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("BREADCRUST")]), _vm._v(" This generic wet fly caddis imitation scores big trout solo or when swung in tandem with a small streamer.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ROYAL WULFF")]), _vm._v(" Split parachute wings let this classic dry ride high through fast water. Use it with a dropper nymph.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("COPPER JOHN")]), _vm._v(" This wirebodied nymph sinks rapidly and stays deep, where many of the where many of the biggest trout lurk.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-13.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("PARACHUTE ADAMS")]), _vm._v(" Arguably the most versatile dry fly ever tied, the Parachute Adams's white post also makes it easy to follow on the drift.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52-15.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box01"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MUDDLER MINNOW")]), _vm._v(" One of the best generic baitfish imitators, this streamer shines in slow or fast water.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t53"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_vm._v("54 TIE A FIVE-MINUTE FLY")])])]), _c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Woolly Bugger is the perfect pattern for a learning fly-tier. It’s big, so you can see what you’re doing, and it involves only a few inexpensive materials. Most important, it’s a proven producer for trout, bass, and almost anything in between. The savvy angler always has at least a few Buggers in the fly box.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Wrap a piece of black 6/0 thread along the length of a size 10 elongated hook. Always wrap the thread away from yourself, over the top of the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Secure one large black marabou feather at the front of the hook and wrap all the way back to the bend. You want to leave enough exposed to create a tail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Connect a 2-inch piece of fine copper wire by the tail and also a strand of black chenille. Wrap the thread forward then the chenille, but leave the wire behind. Tie off the chenille with a half hitch.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Now tie on a saddle hackle feather (black or grizzly), palmer it back (i.e., wrap with spacing), and secure this with a couple of wraps of the wire. Trim the leftover hackle. Wrap the wire forward and tie it off with the thread. Trim the excess wire.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 5")]), _vm._v(" Finish the fly with a tapered thread head. Use a whip- finish knot, apply a dab of head cement, and you’re done.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t54"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t55"
    }
  }, [_vm._v("55 MAKE A SEINE")])])]), _c('a', {
    attrs: {
      "id": "t55"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A seine net is how you catch the small critters that live in the shallows. Why would you want to? See Tip 56. Want to learn how to make one? Read on. First, cut a 1 × 2-foot piece of fine-mesh netting. The lighter colored the mesh, the better. Next, cut two 2-foot lengths from a ⅜-inch wooden dowel. Finally, attach the netting with duct tape onto the dowels so the net is 1 foot wide. Roll it up like a scroll and shove it in a vest pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t55"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t56"
    }
  }, [_vm._v("56 KNOW YOUR BUGS")])])]), _c('a', {
    attrs: {
      "id": "t56"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of grabbing a fly and hoping that you’re close, get some inside information by seining a stream before you fish it. First wade out to where fish typically hold. Firmly grasp a small hand seine downstream of your feet on the creek bottom and turn over a dozen or so rocks. Bring up the net and look closely. Also check the surface flow in the current below if fish are actively feeding around you. You should pick up hatching insects, as well as any terrestrials that have the fish turned on. You don’t need to be an entomologist to figure out what to do with what you seine.")]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("MAYFLY NYMPHS")]), _vm._v(" come in many forms depending on the particular species: crawling, swimming, and burrowing. Try to match the general size, color, and profile of the insect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55a.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("STONEFLY NYMPHS")]), _vm._v(" are often large and can’t swim, so they crawl from stream bottoms to dry land or overhanging vegetation to emerge. Match color and size to entice trout.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55c.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55d.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("CADDISFLY NYMPHS")]), _vm._v(" have two aquatic life stages. The larva lives in a tiny tube made of twigs and sand. It then seals itself into a case to pupate and grow legs and wing pads.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55e.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55f.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t56"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_vm._v("57 MAKE THE MOST OF A SPRINGTIME POND")])])]), _c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a warm spring day, your best flyfishing may be had on ponds and small lakes, which warm up before area streams and rivers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STAY DRY")]), _vm._v(" The predominant still-water bugs are midges, which can provide fabulous dry-fly action. Try a Griffith’s Gnat or a Grizzly Cluster in size 18 or 20. Use a light tippet, starting with 5X or 6X and working smaller if necessary. You don’t want to make much surface commotion, so cast only to rising fish. Cast to a spot about 3 feet above the water, and your fly will fall gently to the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET DOWN")]), _vm._v(" Trout eat most of their food below the surface, which is why nymphing can be deadly. Focus your attention on vegetation and structure, such as timber, rocks, and inlets. Don’t use heavy weights or strike indicators. Cast to your target, let the fly sink, and then work it with deliberate 2-inch strips. A size 16 soft-hackle Pheasant Tail or Hare’s Ear usually gets the job done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GO UGLY")]), _vm._v(" You don’t expect aggression from early-spring trout, but the right streamer fly can bring it out in them. Try a tandem rig. Start with a large, white attention-getter, like a size 10 Zonker. Tie a foot or so of tippet onto its shank and add a trailing “stinger” fly, like a size 12 black Woolly Bugger. With a floating line, your leader should be at least 6 feet long. With a sink tip, you can go down to just a few feet. Be sure to let the flies sink after your cast. Then mix up your retrieves until you figure out what works. Trout often turn on the bright fly and then inhale the dark one.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t57"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_vm._v("58 PRACTICE ANIMAL MAGNETISM")])])]), _c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The long, flexible hair from a deer’s tail is widely used in making bucktail jigs as well as streamer flies like the Clouser Deep Minnow. Deer body hair, meanwhile, is shorter, stiffer, and hollow. It can be spun around a hook shank with thread and trimmed to make floating bass bugs. In either case, you can have the satisfaction of catching fish with lures and flies made from your own trophy, if you happen to hunt. Here’s a quick cut to get you there.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CUT AND CURE")]), _vm._v(" Start with a fresh deer tail cut at its base from the hide. Slice open the hide to expose the tailbone and remove the bone, starting at the base and working on the underside. Scrape away as much fat and tissue as possible. To get the right deer body hair, cut a few hide pieces about 4×4 inches in both white (belly) and brown (back or side) shades, and scrape. Coat the scraped hide with salt and allow to cure, which will take a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("COLORS TO DYE FOR")]), _vm._v(" After the hide dries, gently wash your bucktail or body-hair patches in lukewarm water, using a standard household detergent. Rinse thoroughly to get rid of grease and grit. Air-dry the natural-colored hair, unless you plan to dye it, in which case keep it wet while you ready a dye bath. Deer hair is easily colored with common fabric dyes such as Rit or Tintex. Believe it or not, one of the best dyes to use for some colors such as orange or purple is unsweetened Kool-Aid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most useful color for both flies and jigs is natural white; save at least one tail without dyeing it. For, say, smallmouth bass jigs, you’ll probably want to dye some tails in green, brown, and orange shades so your jigs will imitate crayfish.")]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('b', [_vm._v("TROPHY BUCKTAILS:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(A) Bucktail jig")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(B) Mickey fin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(C) Frankie Shiner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(D) Hot Lips saltwater jig")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(E) Clouser Minnow")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t58"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t59"
    }
  }, [_vm._v("59 JIG YOUR BUCK")])])]), _c('a', {
    attrs: {
      "id": "t59"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Making a bucktail jig is easy. Clamp a jighead by the hook bend in a fly-tying vise or locking pliers. Fasten some fly-tying or polyester sewing thread right behind the jighead. Separate and grab a 1/8-inch-diameter clump of white bucktail with your thumb and index finger. Cut this clump at the base of the fibers. Hold it next to the jig—hair tips to the rear—to gauge desired hair length, then trim the butts accordingly. Now hold the clump so the butts are just behind the jighead and secure the butt ends of the hair fibers to the hook shank with six to eight tight turns of thread to anchor the hairs onto the hook. Continue adding clumps of hair all the way around the jig. Finish with a few half-hitch knots or, ideally, a whip-finish knot. Finally, coat the thread wraps with hard-finish nail polish.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t59"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_vm._v("60 CATCH A TROUT’S ATTENTION")])])]), _c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flies either imitate natural bugs or they attract the attention of fish. A new synthetic called Ice Dub, when wrapped into the body of a fly, does both. Classic nymph patterns like the Hare’s Ear and Prince look just as realistic when they are tied with Ice Dub, yet they also flash and draw eyeballs—especially in low-light conditions—better than the same patterns tied with natural fur and feathers. In flyfishing, seeing is half of the believing equation for trout, and Ice Dub commands notice better than anything else.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t60"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_vm._v("61 TIE A CLOUSER MINNOW")])])]), _c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Clouser Minnow catches trout, smallies and largemouths, and saltwater fish. And as you’re about to see, it’s a cinch to tie.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Lock a hook into the vise. Create a base with white 3/0 thread, starting near the hook eye; attach a dumbbell-weighted eye with figure-eight wraps. The eyes should be on top of the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Dab head cement at the base of the dumbbell wraps. Place a few strands of Flashabou in front of the dumbbell and wrap back, with the Flashabou lined up on the bottom of the shank.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Rotate the vise and repeat with a strand of colored bucktail (chartreuse is great).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Secure the bucktail in front of the head and whip finish it.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t61"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_vm._v("62 MAKE FLIES, NOT BUGS")])])]), _c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Winter is when many people get serious about tying flies for next spring. Make sure your materials are sealed in plastic bags together with a few moth flakes. Otherwise, dermestid beetle larvae may start chewing and destroying them. (These are the same larvae that taxidermists use to clean animal skulls.) Be especially wary if you borrow or are given a rooster neck or bucktail from someone else, or you might find your entire collection infested.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p58.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t62"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t63"
    }
  }, [_vm._v("63 JOIN THE BASS BUG REVOLUTION")])])]), _c('a', {
    attrs: {
      "id": "t63"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The essence of flyfishing for bass is a kind of laid-back antidote to trout fishing’s match-the-hatch intensity. Bass bugs are fanciful rather than factual, full of wanton wiggles as they pop, slide, or slither among the lily pads of summer. Here’s a close look at some of the best.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TOP PICKS")]), _vm._v(" Poppers and sliders are both essential patterns for topwater fishing, and new dense foam bodies float better and last longer than older cork versions. Soft silicone-rubber legs, meanwhile, add lifelike movement that drives bass nuts. Cup-faced poppers make lots of surface noise when twitched, stirring up lethargic fish. Sliders, on the other hand, make a slow and quiet surface wake when stripped with intermittent pauses. Not all modern bass bugs are high floating. The Polk’s Dirty Rat swims with only its nose above water when retrieved—just like a mouse. There’s also the Chubby Gummy Minnow, a fly caster’s version of the soft-plastic jerkbaits used by conventional bass anglers. Its soft, shiny body is a great imitation of the threadfin shad that are common forage in many lakes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FLY LURES")]), _vm._v(" Fly anglers are now imitating other bass lures, and the results can be terrific. They’re heavy enough to sink but not so much that they rocket to the bottom. Because bass often hit while the fly is sinking, a slow drop can be a good thing. There are equivalents for soft-plastic worms, too, based on a long, flexible strip of wiggly rabbit fur. That soft fur has more bass-tempting wiggle in the water than even the softest of plastics. The fly also has a lightly weighted head to give a jiglike action when retrieved. Rabbit-fur flies do raise one critical point: Fur soaks up lots of water, and the weight becomes very difficult to cast with lighter gear. Although smaller, lighter bugs can easily be cast with trout tackle, bigger flies require a heavier line and rod. Eight- to 10-weight rods are not too big for larger bugs, and they’re best coupled with a bass-taper fly line. This is not dainty stuff. When a 6-pound bass smashes your bug, those same heavier rods have enough power to keep the fish from diving back into cover. So not only will you have the fun of awesome surface strikes—you might even land the fish, too.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59e.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t63"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_vm._v("64 EXPERIENCE FATAL ATTRACTION")])])]), _c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Absent an obvious hatch, you want a fly pattern that’s buggy enough to earn interest, gaudy enough to cause a reaction strike, or just plain meaty-looking enough that the trout cannot let it float by. You want an attractor. Here are four of the best. Don’t fish without them.")]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "col4"
  }, [_c('b', [_vm._v("THE PATTERN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("WHY IT WORKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Replicates a range of natural insects, from stoneflies to caddis to hoppers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A brown body gives it crayfish appeal, and the rubber legs drive trout wild.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s a Prince Nymph on steroids with soft hackle wing accents to oscillate in water.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No natural food packs more protein power than mice; a big meal for big fish.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("WHEN TO FISH IT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spring through fall, especially midsummer.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s not a fall-only pattern. Fish it year-round.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Year-round, but it’s most deadly in spring and summer.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Summer nights when big trout are on the prowl.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("HOW TO WORK IT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dead-drift the fly tight to banks. The seductive legs will do the rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bang the banks, then retrieve the fly with fast, erratic strips.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make it the lead fly on a double rig and dead-drift it through deep runs.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make short, erratic strips toward the shore, above runs, and around cover.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("TYING TWEAK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("For dirty water, increase the flash with a sparkle- dubbing body.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the conehead weight for softer presentations to lake fish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mix and match head-dubbing colors to find the real money mix.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dab a spot of glow-in-the-dark paint on the head so you can see it at night.")])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t64"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t65"
    }
  }, [_vm._v("65 GET THE INSIDE SCOOP ON FLY REELS")])])]), _c('a', {
    attrs: {
      "id": "t65"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A spinning reel that costs $30 is going to function mechanically the same as one that costs $1,000. Fly reels, however, are different. If you’re in the market for a new one, understanding the advantages and disadvantages of the two most common styles of internal gears can help you determine how much to spend and which reel is best for you. It ultimately boils down to what species of fish you intend to hook, and how hard that fish is going to fight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p60a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("CLICK-PAWL DRAG")]), _vm._v(" In the early days of flyfishing, all reels featured a click-pawl drag. In a simple configuration, a gear fixed to the back side of the spool locks into triangle-shaped clickers held in place with tension on the inside of the reel frame. When the spool turns, the clickers keep up tension to stop the line from overrunning, as well as to stop the spool from moving in reverse. Some click-pawl reels feature adjustment knobs that allow the angler to change the amount of pressure on the clickers, thus making it easier to reduce tension when stripping line off to cast, and adding it when a fish is pulling against the reel. Click-pawl drags are still popular today, but they are mostly found on inexpensive reels. Click-pawls also are typically reserved for chasing smaller fish, such as stream trout and pond bass. It doesn’t make much sense to spend a ton of money on a click-pawl for small-water applications, as the reel is little more than a line holder.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p60.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("DISC DRAG")]), _vm._v(" Disc-drag fly reels are certainly more than line holders. These reels use a series of stacked washers sandwiched between plates covered in materials like cork or carbon fiber that be can compressed or decompressed via a drag adjustment knob to increase or decrease tension. Disc-drag systems factor in the amount of heat generated when a fish is spinning the drag quickly, as well as the torque applied during a hard run. It’s disc-drag reels that can cost a pretty penny depending on the material used in construction. But if you’re chasing salmon, steelhead, striped bass, or tuna that are going to take a lot of line off the reel, you’ll want the reliability of a solid disc drag. Many disc drags are also sealed within the reel frame by a metal housing. This is particularly important to look for if the reel will be used in saltwater, as the housing keeps water out of the drag, thwarting corrosion and making sure moisture between the discs doesn’t compromise the drag’s performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p61.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t65"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_vm._v("66 UNDERSTAND YOUR FLY REEL")])])]), _c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fly reel has three basic purposes: to store line and backing, to provide a smooth drag against a running fish, and to balance your rod’s weight and leverage. Even the most complex flyfishing reels are simpler than an average spinning reel, but it still behooves you to understand how to best utilize this vital piece of gear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flyfishing reels don’t revolve during a cast, since fly anglers strip line from the reel and let it pay out during the back-and-forth motion called “false casting.” In the past, fly reels have served largely as line-storage devices with simple mechanical drags. Advancing technology and an increase in interest in flyfishing for big, strong-fighting fish have led to strong drag systems that can stop fish as large as tarpon. Other recent developments include warp- and corrosion-resistant materials and finishes and larger arbors—the spindles around which the line is wrapped—that reduce line coils and help maintain consistent drag pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FRAME")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Holds the spool. A weak frame will warp, causing friction as the spool revolves.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DRAG KNOB")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adjusts drag tension. Some smaller reels have click-pawl drags, while reels for larger fish sport strong cork and composite disc braking systems.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("HANDLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike with spinning and baitcasting reels, rotating the handle of a fly reel typically turns the spool a single revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SPOOL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many reels are fitted with removable spools. Having different fly lines ready on a number of spools allows an angler to switch tactics more quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("ARBOR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The spindle around which the fly line is wrapped. Many modern reels have larger arbors that help recover line more quickly when a fish swims toward the angler.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t66"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t67"
    }
  }, [_vm._v("67 GET IN LINE")])])]), _c('a', {
    attrs: {
      "id": "t67"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike a spinning or conventional outfit where the reel and the bait’s or lure’s weight dictate how far you cast, when it comes to flyfishing, the reel won’t gain you distance and what’s tied to the end of the line doesn’t matter. What you’re actually casting is the line, and the fly you choose simply makes it more or less difficult to cast that line properly. The type of water, proper presentation of certain styles of fly, and the pursuit of different species sometimes call for specialty fly lines. These are the four most common; picking the right one will up your success with the long rod.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p62.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("INTERMEDIATE LINE")]), _vm._v(" Often clear or lightly colored, intermediate line is heavier than floating line but lighter than a full-sink line. This line is designed to sink slowly, allowing you to present flies to fish holding in the middle of the water column. The coloring helps it blend into the surroundings underwater, and it is widely used by saltwater flyfishermen chasing wary species like striped bass and freshwater anglers who strip streamers in clear lakes and deeper rivers for everything from trout to smallmouth bass to muskies. Though you can use an intermediate line to present trout flies in streams, one disadvantage is that it’s harder to see the line in the water, which can make detecting subtle strikes tricky.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p62a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("SINK-TIP LINE")]), _vm._v(" Sink-tip lines offer the ease of casting of a full-floating line, but with the addition of a 5- to 12-foot tip section that sinks. These lines are popular for streamer flies that are stripped back to mimic baitfish in the water, but can also be used to fish nymphs and wet flies in deeper rivers and lakes. A sink-tip line is ideal for fishing water in the 5- to 10-foot depth range, but can work in shallower water when you need to get your fly into the zone quickly. If, say, you are floating in a drift boat and want to strip a streamer through a deep pocket, a sink-tip line will let the fly sink into the pocket fast, giving your fly maximum time in the strike zone when you have only a few seconds in which to make your presentation.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p63.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FLOATING LINE")]), _vm._v(" The vast majority of flyfishing situations call for a full-floating line. Whether you’re presenting dry flies on a trout stream or bass bugs on a lake, floating lines cast the easiest and most accurately. Even if they need to fish a wet fly or nymph below the surface, most fly anglers aren’t fishing areas deeper than 6 feet or so, or are targeting fish holding higher in the water column. The 7- to 12-foot leader you’d use with a floating line is typically long enough to allow your flies to reach the proper depth. Floating line also acts as its own strike indicator; when swinging a fly below the surface, keep an eye on the point where the fly line meets the water and watch for tics and stops. It’s important to treat floating lines with dressing to keep them supple and slick for good castability. If they crack or lose their coating, they may not float as well. You can also find specialty floating lines that perform best in warm or cold water.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p63a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FULL-SINK LINE")]), _vm._v(" Though it’s not very fun to cast, full-sink lines exist for special situations, and for the anglers who like to push the limits of flyfishing. In saltwater, a full-sink might be in order to get a fly down 20 feet or more in a hurry to a school of bluefin tuna. In freshwater, anglers use full-sink lines to get streamers to the deepest, darkest holes in lakes and rivers where monster trout and bass live. Sinking lines are generally configured by grain, which translates to weight, thus telling you how many feet or inches per second that line will sink. The drawback to a full-sink line is that it has no versatility, so while one hole in the river may call for it, you’ll likely be hanging flies in the rocks all day in areas of shallower depths. But if you think there is a huge pike on the bottom in 25 feet of water at your favorite lake and you insist on catching it on the fly, a full-sink might be the only way to get a streamer in front of its face.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p64.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t67"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t68"
    }
  }, [_vm._v("68 BUCK THE WIND")])])]), _c('a', {
    attrs: {
      "id": "t68"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Don’t overload your fly rod with a heavier line to make longer casts into strong wind. Instead, try going one level lighter than the rod’s recommended line weight. This will underload the rod, causing it to flex less and allowing you to cast a tighter line loop. Rather than being dispersed over a wide arc, the energy of your cast will flow toward your target, extending distance.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p65.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t68"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_vm._v("69 MASTER SHORTER CASTS")])])]), _c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Long casts, while impressive, are often overkill. What matters most in the real fishing world is accuracy under pressure. This exercise helps you master shorter casts—get it right and you will hook more fish, from trout rising in the river to bonefish cruising the flats. It’s a great two-person game you can play in the back yard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Set out five targets (trash-can lids, hula hoops, doormats, whatever) at 40 feet. When the caster is ready, the timekeeper calls a random target, one through five. Using a stopwatch, he or she counts four seconds. The caster must hit the target before time is called. Mix it up and then trade places.")]), _vm._v(" "), _c('div', {
    staticClass: "box05"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("HOW TO IMPROVE A BAD SCORE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p65a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("LINE IT UP")]), _vm._v(" This drill makes judging distance second nature, so you focus on aiming the cast, not measuring line. Start by paying out 20 feet of line, draping 10 from the end of the rod and coiling 10 near your feet. Then hold the fly in your off hand. (Factor in a 9-foot leader between the line and the fly, and you’re most of the way to 40 feet.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p65b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("BACK CAST CORRECTLY")]), _vm._v(" To get that slack line airborne, you'll first need to roll cast away from you, off target, and release the fly. Next, fully load the rod on the back cast. If you start by yanking backward and pulling the fly out of your hand, you’ll only get yourself tangled. Strip out the remaining line as you make one false cast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p65c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GO THUMBS UP")]), _vm._v(" Once the line is in the air, focus on the target. Use your thumb to direct the cast. The rod tip ultimately tells the line (and fly) where to go, and the thumb tells the rod tip what to do. When you shock the rod and make your final cast, if the target is lined up at the tip of your thumbnail, odds are your fly will land on the money.")])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t69"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t70"
    }
  }, [_vm._v("70 CAST ABOUT")])])]), _c('a', {
    attrs: {
      "id": "t70"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To vary your routine, start short and then lengthen each cast by 10 feet. By varying the distance, you make your lure or fly swing on a different arc with each retrieve. It will pass through more positions where fish may be holding. After you’ve covered all the water you can reach, change position and begin again.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p66.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t70"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t71"
    }
  }, [_vm._v("71 LOSE THE TAILING LOOP")])])]), _c('a', {
    attrs: {
      "id": "t71"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A tailing loop occurs when the fly and leader dip below your line on the forward cast, usually causing a tangle. It is to a fly caster what a slice is to a golfer: an all-too-common problem caused by a simple mechanical flaw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vast majority of tailing loops are caused by overpowering or “punching” the rod on the forward stroke. It’s human nature. Trout are rising; you’re making your false casts and have a nice loop going. All you need is that extra 10 feet, just a little more oomph, and dang! Bunched up again. When you overpower the rod, you flex it too much and actually shorten its length in midstroke. This changes the path of the tip and the line, causing the tailing loop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How to fix this? Try imagining that you have a tomato stuck on the end of a stick, and you want to fling that tomato into a bucket, say, 20 feet away. If you whip the stick, you’ll end up splattered with red mush. But if you gradually fling the tomato off the stick, you might get it there. Same deal and same feel with the fly cast. The motion must be a gradual, controlled acceleration to an abrupt stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you still have trouble developing this feel, practice in your backyard. First, tilt the rod sideways and cast from waist or chest level on a flat plane in front of you so you can watch the line. Start with short flicks of line. You should see and feel good U-shaped loops as well as bad tailing loops. Eventually the good loops will become uniform, and you’ll be able to lift that cast overhead, still feeling how the line shapes. Once you get the feel for this, you’ll stop tailing, your loops will get tighter, and your casts will go farther.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p66a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t71"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t72"
    }
  }, [_vm._v("72 CONTROL YOUR WRIST")])])]), _c('a', {
    attrs: {
      "id": "t72"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The No. 1 mistake novice fly casters make is going back too far on the back cast. The only tip-offs are the noises of line slapping the water or the rod tip scraping the ground behind them. This happens, more often than not, because the caster is allowing his wrist to cock too far back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember this: The arm is the engine; the wrist is the steering wheel. Yes, sometimes it’s “all in the wrist,” but that pertains to matters of aiming the cast, not powering it. When you let your wrist power your cast, you will crash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To correct this, get a large, thick rubber band, wrap it around your casting wrist, then insert the rod butt inside the band when casting. If the band is flexing too much, the odds are that you are breaking your wrist too far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are wearing a long-sleeved shirt, tuck the rod butt inside your cuff. It will have the same effect.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p67.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t72"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t73"
    }
  }, [_vm._v("73 POINT YOUR SHOTS")])])]), _c('a', {
    attrs: {
      "id": "t73"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s axiomatic that the fly line, and thus the fly, follows the rod tip. Taking that one step further, the rod tip follows the thumb, which is the strongest digit and the one most anglers place on top of the grip for power and direction. Lee Wulff used to cast with his index finger on top, because he felt it gave him better control. He was an exception to the rule. No matter. As long as you keep your thumb—or index finger—pointed at the target, your cast will go where you want it to.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p68c.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t73"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t74"
    }
  }, [_vm._v("74 KEEP FLIES IN MINT CONDITION")])])]), _c('a', {
    attrs: {
      "id": "t74"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aside from sparing your fishing buddies from your coffee breath, there’s another reason to eat Altoids: The empty tin makes for an ideal fly box. And if one of those pals who’s suffered your coffee breath before is new to flyfishing, apologize with one of these. It’s the perfect beginner’s fly box.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p68.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Clean the mint dust from the tin. Next, cut the following from a shoebox: one 3½ x ¾-inch strip to fit lengthwise inside the tin, and two 2⅛ x ¾-inch strips to fit widthwise.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p68a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Cut two notches halfway through the longer strip. Do the same down the center in each shorter strip. Insert the shorter strips into the longer piece at the notches.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p68b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Wrap the cardboard with duct tape. The tape strengthens the cardboard, protects it from water damage, and gives the grid a snugger fit inside the tin.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t74"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t75"
    }
  }, [_vm._v("75 FISH THE CYCLE")])])]), _c('a', {
    attrs: {
      "id": "t75"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 1496, Dame Juliana Berners described fly imitations for about a dozen mayflies in her "), _c('i', [_vm._v("A Treatyse of Fysshynge wyth an Angle")]), _vm._v(". And so it began. There are more than 500 species of mayflies known to North America, and no telling how many mayfly patterns. Here’s how to match the fly to the mayfly life stage.")]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('span', {
    staticClass: "col4"
  }, [_vm._v("Nymph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ABOUT THE PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As nymphs feed and molt, they move about the stream and become dislodged in the current. Trout whack them.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69d.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Pheasant Tail Nymph")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Copper John")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FISHING TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is when mending means the most, to drift cleanly through riffles and runs.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('span', {
    staticClass: "col4"
  }, [_vm._v("Emerger")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ABOUT THE PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mayflies beginning to hatch rise to the surface, crawl to water’s edge, or shed skin underwater. Trout go wild for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69e.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Klinkhammer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. Emerging Para Dun")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FISHING TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you see a trout head bulging out of the water, it’s likely feeding on emergers.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('span', {
    staticClass: "col4"
  }, [_vm._v("Dun")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ABOUT THE PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Young adults drift on the surface until their wings dry. Still weak, they fly to a protected area to molt a final time.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69f.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("5. Sparkle Dun")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6. Comparadun")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FISHING TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If duns don't work on top, let them sink into the film")])]), _vm._v(" "), _c('div', {
    staticClass: "boxd"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('span', {
    staticClass: "col4"
  }, [_vm._v("Spinner")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69c.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ABOUT THE PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the final adult breeding stage. When the dying insects fall to the water, wings outstretched, trout go nuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p69g.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("7. Angel Wing Spinner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8. Krystal Spinner")])]), _vm._v(" "), _c('div', {
    staticClass: "boxf"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("FISHING TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use a dropper rig with a larger fly as an indicator and a small submerged spinner trailer.")])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t75"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t76"
    }
  }, [_vm._v("76 MAKE A BEER-BOX STRIPPING BASKET")])])]), _c('a', {
    attrs: {
      "id": "t76"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A stripping basket prevents loose line from blowing around and elevates coils of longer lines, reducing the energy they need to make it up to the stripping guide.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Head to the local watering hole. If you’re vacationing somewhere tropical without a bar (if that even exists), find the closest grocery store.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Ask the bartender for an empty case from bottled beer (or a full case that you’ll empty later). Tip the mixologist a dollar or two and find the local hardware store.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Get about 10 feet of yarn, string, or rope. This will be hanging around your neck, so make sure the material is wide and soft enough that it won’t rub your skin raw. In a pinch, use the thickest piece of monofilament in your tackle and apply a length of tape where it contacts your neck.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Punch a hole 3 inches from the top on both sides of the box. Attach the string so that the box comes to your waist. To get fancy, ask a restaurant for two large egg trays. Cut to fit in the bottom of the case, they make cone spacers that further help keep the line snarl free.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p70a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t76"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t77"
    }
  }, [_vm._v("77 ACCESSORIZE YOUR TACKLE BOX")])])]), _c('a', {
    attrs: {
      "id": "t77"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You need more than lures. Here are eight items that experienced anglers always have on hand.")]), _vm._v(" "), _c('div', {
    staticClass: "boxa"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("1. FLASHLIGHT")]), _vm._v(" It’s handy whenever you’re out after dark, essential if you’re stranded and have to signal for help.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("2. ADJUSTABLE WRENCH")]), _vm._v(" This has a wide variety of uses, from opening reel covers to tightening trolling-motor bolts.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("3. SPLIT-RING PLIERS")]), _vm._v(" They open split rings and allow you to replace hooks quickly and easily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("4. LURE DYE")]), _vm._v(" With Spike-It lure dye, you can change a lure’s hue in seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("5. FIRST-AID SUPPLIES")]), _vm._v(" Don’t let a minor injury ruin your day. If you bury a hook in your hand, for example, some simple supplies will let you take care of the problem on the water—and keep fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("6. SPARE TREBLE HOOKS")]), _vm._v(" Hooks often become dull or damaged when worked over rocks and gravel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("7. SPARE ROD TIPS")]), _vm._v(" If you’ve never snapped off a rod tip, you will.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("8. GLUE STICK AND LIGHTER")]), _vm._v(" Use these to affix a new rod tip. Heat the glue stick with the lighter, apply the glue, and then slide on the new tip.")])])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t77"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t78"
    }
  }, [_vm._v("78 MAKE AN ESSENTIAL REPAIR KIT")])])]), _c('a', {
    attrs: {
      "id": "t78"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meet your newest fishing buddy. It’s got everything you need to mend a broken rod tip, patch your leaky waders, and fix broken lures. About that backlash in your baitcaster? You’re on your own.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p71.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('b', [_vm._v("WHAT’S INSIDE")]), _vm._v(" (1) lure markers; (2) reel oil; (3) superglue; (4) wader-repair kit; (5) lighter; (6) electrical tape; (7) split rings; (8) split-ring pliers; (9) hook sharpener; (10) rod wrap thread; (11) dental floss; (12) Fuji guide sets (spinning/baitcasting); (13) epoxy; (14) razor blades; (15) paper clip; (16) spare rod-tip guide; (17) shrink tubing.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p72.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t78"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t79"
    }
  }, [_vm._v("79 MAKE THE ULTIMATE ICE-FISHING BUCKET")])])]), _c('a', {
    attrs: {
      "id": "t79"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET A BUCKET")]), _vm._v(" Start with a standard plastic 5-gallon bucket with a lid to haul gear and provide a seat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("ADD BUNGEE CORDS")]), _vm._v(" Wrapped near the rim, they secure jigging rods and tip-ups to the side of the bucket.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("ORGANIZE")]), _vm._v(" Stash all nonmetallic items with a small tool belt fastened around the bucket. Now you’ve got a great place to stash things like hand warmers, tissues, plastic boxes, bobbers, and snacks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("VELCRO IT")]), _vm._v(" Attach a cushion or a piece of 3-inch foam to the lid. Using Velcro rather than glue allows you to remove the foam easily if it needs to be cleaned or replaced. And it will.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET A GRIP")]), _vm._v(" The handle can also be a storage spot. Get a golf towel (one that comes with an attached clip) and snap it on. Tie on other items that you will use regularly, such as line clippers and a bottle opener.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET ATTACHED")]), _vm._v(" To create handy holders for metal items, buy an assortment of inexpensive magnets. Attach them to the bucket’s sides with an all-purpose glue, such as Gorilla Glue. Set the magnets wherever needed to keep pliers, hooks, and lures in easy-to-reach spots.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p72a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t79"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t80"
    }
  }, [_vm._v("80 PICK THE MOST IMPORTANT TOOL")])])]), _c('a', {
    attrs: {
      "id": "t80"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The tool that can save your life won’t cost nearly as much as all your essential tackle. For $5 to $10, buy a pair of ice picks. These sharp spikes are mounted to handles and tethered together on a lanyard that hangs around your neck, letting the picks dangle in easy reach on either side of your chest. Should the ice break and you fall in, get to the edge of the hole, grab the picks, reach out, and jam them hard into the stable ice. Now you have a way to pull yourself out of the hole. Even if you ice fish with friends, you should always have picks around your neck. It’s a cheap way to ensure you’ll be ice fishing another day.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p73.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t80"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t81"
    }
  }, [_vm._v("81 HIT THE ICE TWO WAYS")])])]), _c('a', {
    attrs: {
      "id": "t81"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whether you’re after perch for the frying pan or a monster pike through the ice, there are two main attack methods that will achieve the goal. Tip-ups are metal, plastic, or wood frames that lie over a hole in the ice. On the underside, hanging in the water, is a spool loaded with line, which runs to a trigger mechanism that locks a flag on a spring or wire in a down position. When a fish grabs the bait, the trigger trips and the flag stands up. The advantage to ice fishing with tip-ups is that you can drill multiple holes and fish multiple baits simultaneously. All you have to do is sit back and watch the flags. However, tip-ups are limiting in that they only allow you to fish a live or dead bait. If you want to work a jig or spoon, you need to do so with an ice fishing rod so that you can impart action to the lure. Many seasoned ice fishermen, especially those hunting for large species, opt for rods, as they allow them to change from a bait to an artificial presentation quickly. Rods also give the angler more control over the fish, which is important if the catch is large and taking drag or putting up a hard fight. Tip-ups don’t have reel, so the angler has to fight the fish by hand. That’s not to say landing a trophy walleye or muskie by hand is impossible, but it definitely takes more skill.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p73a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t81"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t82"
    }
  }, [_vm._v("82")])]), _c('a', {
    attrs: {
      "id": "t82"
    }
  }, [_vm._v(" KNOW YOUR: "), _c('b', [_vm._v("NORTHERN PIKE")])])]), _c('a', {
    attrs: {
      "id": "t82"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Northern pike are the perfect example of a gamefish anglers either love or hate. Fishermen after bass or trout often see pike as a nuisance that steal lures and baits, decreasing the chances for the target species to get hooked. However, that voracious attitude and willingness to attack almost anything that moves have created legions of dedicated pike nuts. These fish can grow past the 40-inch mark like their cousin the muskie, and the current world-record pike weighed 55 pounds. Pike are also not nearly as temperamental and hard to fool as muskies. Whether stocked or naturally occurring, they can be found in most reservoirs, lakes, and rivers in the northern half of the United States, with their range extending into Canada and up to Alaska. Find a weedbed or rocky ledge close to deep water and any live baitfish or stickbait will get crushed.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p74a-75.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t82"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t83"
    }
  }, [_vm._v("83 MIND YOUR MONITOR")])])]), _c('a', {
    attrs: {
      "id": "t83"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a party boat, the captain will let anglers know at exactly what depth fish are holding so that they can count down accordingly—and he’ll keep an eye on when that holding depth changes within a drift. Small-boat anglers, however, don’t always check their finders. “Guys will mark fish at 17 feet, drop lines, and stay at 17 feet for an entire drift,” says walleye expert Ron Boucher. “It’s critical to keep checking the monitor. Sometimes I’ll find fish at 6 feet on one side of a reef and 20 on the other side, a short drift away.”")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p74.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t83"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t84"
    }
  }, [_vm._v("84 GET BETTER SONAR RECEPTION")])])]), _c('a', {
    attrs: {
      "id": "t84"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Don’t fasten the transducer and receiver of your electronic fishfinder directly to your small jon boat. Instead, mount them on short wooden boards extending below the level of turbulence caused by the hull. Use carpenter’s clamps to fasten the boards where you want them, and move this setup around to find the best reception points.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p76.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t84"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t85"
    }
  }, [_vm._v("85 PICK A ROD WITH REACH")])])]), _c('a', {
    attrs: {
      "id": "t85"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you’re nearly on the same level as the water’s surface while wade fishing, a longer spinning rod will definitely improve your game. If you need to jig a seam 30 feet away, the added length lets you keep more line out of the water, reducing drag. Don’t also increase rod stiffness, as you should be able to deliver light jigs and spinners. Opt for a 7½-foot light or medium-light stick with a softer action that will send small grubs flying.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  })]), _c('h2', [_c('a', {
    attrs: {
      "id": "t85"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t86"
    }
  }, [_vm._v("86 DRIFT ON")])])]), _c('a', {
    attrs: {
      "id": "t86"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few drifting tricks can radically improve your success when worm fishing, no matter what your prey may be. Here are two techniques endorsed by pros and weekend fishermen alike.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p77.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DRIFT AWAY")]), _vm._v(" Whether you’re wading or fishing from a boat, drifting worms is one of the great searching strategies to use when you’re fishing bigger rivers. For trout, a spade-dug, 4-inch garden worm is the right size; for bass, walleyes, and steelhead, you’ll probably find that a fat nightcrawler will be a better choice. The key is to drift the bait through feeding and holding areas, because fish in current are not going to chase down the bait like they would in still water. Use just enough weight to tick the rocks. Strikes will come as a sharp tug rather than a pull or rap. Fish the transitions, which is to say the mouths of tributaries, as well as bankside slicks and along the edges of big pools.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p77a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("FOLLOW A FLOAT PLAN")]), _vm._v(" Back in the day, no largemouth fisherman worthy of the name would be caught dead without a few bobbers in his tackle box. The thinking at the time was that a bobber allowed for a precise presentation, usually just above the weeds. You know what? Those guys were right . . . and they still are today. Properly positioned like this, a nightcrawler becomes a deadly bait for pond bass. The trick is to drift along a transition in weed height or density, trailing the worm behind the boat, and using as little weight as possible and a quarter-size float so that the fish won’t feel resistance when it takes the bait. Try it at first and last light. Full sun scatters largemouths and emboldens panfish, which rip apart floating crawlers.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p77b.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t86"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t87"
    }
  }, [_vm._v("87")])]), _c('a', {
    attrs: {
      "id": "t87"
    }
  }, [_vm._v(" KNOW YOUR: "), _c('b', [_vm._v("BLUE CATFISH")])])]), _c('a', {
    attrs: {
      "id": "t87"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Head to the South and it won’t be hard to find a diver who swears he’s encountered a blue big enough to swallow a man in the local lake, or an angler who swears she hooked a blue so big there was no hope of winning the fight. Though man-eaters are unlikely, these fish do frequently top 100 pounds, with the world record standing at a brutish 143 pounds. Blue cats are natives of the Mississippi River drainage but have also been introduced to Eastern rivers and Southern lakes. To drop a jaw with a blue cat, you’ve got to catch one heavier than 40 pounds, and to do that, most anglers lean on fresh-cut shad baits or live shad. Despite popular belief that catfish love stinky, rotting baits, most blue cat aces will tell you the fresher the bait, the bigger the cat. Many catfish pros lean on heavy gear usually reserved for saltwater pursuits.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p77c.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t87"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t88"
    }
  }, [_vm._v("88 GRUB A SPINNER")])])]), _c('a', {
    attrs: {
      "id": "t88"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Light in-line spinners perfectly mimic the baitfish found in smaller rivers. Here’s how you can catch more with a single-hook model. Thread a small white or chartreuse curly-tailed grub onto the hook and position yourself at the head of a long run. Make a long cast downstream and let the spinner hang in the current, advancing it forward a foot or so every half minute. Even reluctant fish will often get annoyed and smack it.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p78a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t88"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t89"
    }
  }, [_vm._v("89 NET A HELLGRAMMITE")])])]), _c('a', {
    attrs: {
      "id": "t89"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The usual way of collecting hellgrammites involves holding a seine net or a screen stretched between stakes while rocks are lifted upriver. This is difficult to do alone, however, and carrying a seine or a screen isn’t practical when you need to be mobile. That’s where a fine-mesh trout net comes in. Simply hold the net on the downstream side of a rock roughly the same diameter as the net’s hoop and then lift the rock up and away from the net, allowing the current to sweep any hellgrammites down into the mesh. Once you’ve hooked your trophy smallmouth on the hellgrammite, you can then use the net to scoop it from the water.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p79a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t89"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t90"
    }
  }, [_vm._v("90 WADE AFTER YOUR BASS")])])]), _c('a', {
    attrs: {
      "id": "t90"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The biggest advantage a wading angler has is the ability to stay put and pick a stretch of water apart for the most and biggest smallmouths, as opposed to getting a few fleeting casts from a drifting boat. Just don’t risk injury or worse at the mercy of swift current; if you’re not comfortable reaching a spot, skip it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s the most practical and efficient way to be sure you comprehensively cover stream eddies, where smallmouths like to station themselves and feed. Position yourself three-quarters of the way up the eddy closer to the head. From here, you’ll be able to make four presentations with a spinner, crankbait, or jig in a single cast. Start by casting upstream of the eddy head (A) and working the lure downcurrent. After a few cranks, as your line is pulled along the eddy, work the lure straight across.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turn the reel handle a few more times and stop, allowing the lure to swing down toward the eddy’s tail (B), then retrieve straight upcurrent for the recast (C). In this manner, your lure is presented down, across, on the swing, then directly upcurrent in one sweep, and you can quickly determine which presentation the bass like best.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p79.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t90"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t91"
    }
  }, [_vm._v("91 DRIFT A HELLGRAMMITE")])])]), _c('a', {
    attrs: {
      "id": "t91"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hellgrammites arguably catch more big small-mouths than any other bait. The trick is presenting one naturally with the current. If you drift one cross-current with a split shot, the weight often hangs. Instead, drift it unweighted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Position yourself 30 or 40 feet upstream of your target. Face downcurrent, keep your rod low, and begin peeling line off the spool (D). An unweighted hellgrammite will be close to the bottom by the time it nears the fish. Keep feeding line so the bait won’t spin or stop. If the line coming off the reel increases in speed, your hellgrammite just got picked off. Hook the hellgrammite through the collar, the rigid body section behind the head; the bait will often slide up the line after a hit, so you can reuse it several times.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p80-81.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t91"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t92"
    }
  }, [_vm._v("92 RELEASE YOUR ANCHOR QUICKLY")])])]), _c('a', {
    attrs: {
      "id": "t92"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It can be difficult to land large fish from a boat anchored in strong current if you can’t slip anchor quickly. To make a quick-release system, tie a loop in the anchor line and attach a buoy or plastic jug to the loop, which you will place around the bow anchor cleat. When you hook up, slip it off the cleat and toss it overboard. After you’ve landed the fish, retrieve the anchor and buoy.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p81a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t92"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t93"
    }
  }, [_vm._v("93")])]), _c('a', {
    attrs: {
      "id": "t93"
    }
  }, [_vm._v(" KNOW YOUR: "), _c('b', [_vm._v("RAINBOW TROUT")])])]), _c('a', {
    attrs: {
      "id": "t93"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Originally native to the West Coast from California to Alaska, rainbow trout are now one of the most widely stocked species in the country, available in everything from neighborhood lakes to the mountain streams of the Rockies and Appalachians. Wild rainbows are particularly prized for their brute fights and aerial acrobatics on the line. Unlike brown trout, which will sometimes lie low and be choosy about meals, rainbow trout, by and large, are more aggressive. These fish will strike streamer flies and jerkbaits with crushing blows. At the same time, stocked rainbows can be fooled with a simple garden worm or be keyed into a very specific bug hatch, gently sipping flies off the surface. Of all the places these fish live, Alaska is still considered by many to be rainbow Mecca. The trout here get fat on salmon eggs, and frequently hit the 20-pound mark in rivers like the Kenai.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p82.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t93"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t94"
    }
  }, [_vm._v("94 CAST FROM A KAYAK")])])]), _c('a', {
    attrs: {
      "id": "t94"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("For easy casting from a kayak, install a movable anchor system. Mount pulleys near both ends of the craft and run a 3/16-inch braided nylon line through them and tie the ends to a strong metal or plastic ring. Insert your anchor line and tie it off to a deck cleat. Use the pulley line to move the ring forward or back, adjusting the anchor pull-point until the kayak lies in a comfortable casting position for your target area.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p82a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t94"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t95"
    }
  }, [_vm._v("95 TIE A TRUCKER’S HITCH KNOT")])])]), _c('a', {
    attrs: {
      "id": "t95"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This versatile knot is great for tying down heavy or unwieldy loads for transporting. Use it to tie your canoe or kayak to roof racks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Loosely loop your rope as shown, leaving the tail end free.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Feed the tail end through your anchor point and then through the loop you made in Step 1.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Loop the free end into a half-hitch knot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 4")]), _vm._v(" Tighten all knot points down well for safety.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p83.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t95"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t96"
    }
  }, [_vm._v("96 AVOID RIVER OBSTACLES")])])]), _c('a', {
    attrs: {
      "id": "t96"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When two people are canoeing downstream, the best way to steer around danger is for the bow paddler to use draw strokes to the right and left. The stern paddler should make both draw and bracing strokes to pull the body of the canoe in line with the bow and hold it as the craft drifts past treacherous areas. Use forward power strokes only to avoid emergencies.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t96"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t97"
    }
  }, [_vm._v("97 PACK AND PADDLE FOR POWER")])])]), _c('a', {
    attrs: {
      "id": "t97"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To paddle a canoe into a headwind, arrange the load so that the canoe is slightly bow-heavy. The bow will sink deeper into the water, making it less likely to be blown off course. The lighter stern end will follow as the wind pushes it straight behind the bow. To run downwind in open water, reverse the load. You won’t have to correct your direction as often as the wind bears on the stern.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t97"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t98"
    }
  }, [_vm._v("98 TIE A CANOE TO YOUR RACKS")])])]), _c('a', {
    attrs: {
      "id": "t98"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p83a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 1")]), _vm._v(" Place the boat on the rack upside down and centered fore and aft. Tightly cinch it to the racks, using one cam-buckle strap per rack. Do not crisscross tie-downs; be sure to snug your tie-down straps or ropes directly against the gunwales where they cross under the racks.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p83b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 2")]), _vm._v(" Tie two ropes to the bow, and the end of each rope to a bumper. Repeat for stern anchors. Do not use the same rope or strap to create one long V-shaped anchor. Pad lines where they run across a bumper edge.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p83c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STEP 3")]), _vm._v(" Test by grabbing the bow and shifting hard left, right, up, and down. You should be able to rock the entire car without shifting the canoe. Do the same for the stern. Stop, test, and tighten as necessary after 10 minutes of driving.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p84.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t98"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t99"
    }
  }, [_vm._v("99 GET UP THE CREEK")])])]), _c('a', {
    attrs: {
      "id": "t99"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Creek channels provide some of the best action on the nation’s many reservoirs. Learning to hug these structures with your boat goes a long way toward better fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Start by driving at a slow to medium idle speed in a lazy “S” pattern (A) while watching your console-mounted graph for and sharp dropoffs. As you go, toss out marker buoys to delineate the edge of the dropout you plan to fish. Once you’ve marked a stretch with several buoys, kill the outboard and use your trolling motor to reach the middle of the channel. Cast a diving crankbait, jig, or plastic worm perpendicular to the structure, into the adjacent shallower flat. Then work the lure back toward you, down the channel ledge, into deeper water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If this doesn’t work, reposition your boat so it’s directly above the dropoff and cast parallel to it, methodically working the bait back along the channel ledge.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t99"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t100"
    }
  }, [_vm._v("100 BE SNEAKY")])])]), _c('a', {
    attrs: {
      "id": "t100"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most bass are caught in less than 8 feet of water. But you won’t catch them there unless you can slip a big, flashy boat within casting range—without spooking them. Here’s how.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("RUN SILENT")]), _vm._v(" When you approach skinny water, turn your outboard motor off and raise it using the power trim so the skeg doesn’t drag bottom. Keep part of the skeg in the water, however, so it acts as a rudder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET LOW")]), _vm._v(" Lower the trolling motor quietly. Don’t drop it like an armload of bricks! Adjust the motor’s shaft height so it doesn’t bang into stumps and rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STAY STEADY")]), _vm._v(" Avoid constantly hitting the on-off switch as you navigate. Instead, keep the trolling motor on a slow to medium speed. Bass will adjust to a constant noise, but an intermittent noise can spook them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MARK YOUR SPOT")]), _vm._v(" As you work shallow structure, such as a stump flat, keep a marker buoy near your foot. When you hook up, immediately kick the buoy into the water (B). This way, if you drift off this spot while fighting the fish, you can get right back on it—and catch more bass.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p85.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t100"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t101"
    }
  }, [_vm._v("101 GO, SPEED RACER (SAFELY)")])])]), _c('a', {
    attrs: {
      "id": "t101"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Today’s bass boat is a marvel of efficiency—incredibly fast, stable, and smooth on the water. The fastest bass boats are capable of speeds in excess of 75 mph, but it takes skill and seat time to drive them well. Here’s how to pilot your rig safely from a dead stop to top speed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, have your boat dealer’s service center adjust the steering to remove any “slop” (excessive play) in the wheel and make sure the engine height is right for your specific boat-outboard-propeller combination. Next, adjust the gear in your boat so the load is evenly distributed. Skip any of this, and you’re apt to have handling problems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now get on a big, calm body of water away from boat traffic. Fasten your outboard’s kill switch to your life jacket. Crank the engine, trim it all the way under, and when the coast is clear, accelerate. The bow will rise, then fall, as the boat gets “out of the hole” and on plane. Continue accelerating while applying power trim judiciously to lift the bow. Be very careful not to overtrim!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you practice getting a bass boat to speed, instead of running in a straight line, try piloting the boat in a gradual, sweeping arc to the left. This counters the propeller’s torque and makes balancing the boat on its pad easier.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t101"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t102"
    }
  }, [_vm._v("102 KEEP YOUR FOOTING")])])]), _c('a', {
    attrs: {
      "id": "t102"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Create a permanent nonslip surface on your boat deck: First cover it with a coat of polyurethane deck paint. While it’s still wet, use a clean salt shaker to scatter washed sand (sold in bags at hardware stores) evenly over the entire surface. Once the paint is dry, apply a second coat. This binds the sand into the paint, creating a semi-rough deck that is safer to walk on when wet.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p86.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t102"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t103"
    }
  }, [_vm._v("103 DIAGNOSE AND CURE A SICK MOTOR")])])]), _c('a', {
    attrs: {
      "id": "t103"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Among the many early signs of spring is the fisherman standing at a boat dock, having just launched his boat for the first time after winter storage. All too often, he’s scratching his head and wondering why in hell his outboard motor won’t start. Here are some troubleshooting tips and tricks for anyone with a basic set of tools and some rudimentary tinkering skills.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SLOW TO START")]), _vm._v(" First, make sure your starting battery isn’t dead. Next, check that the kill switch is in the “run” position. The kill switch itself might have corroded slightly over the winter. In general, corroded electrical connections are a common problem. When you find a wire terminal that’s green and crusty, it’s time to clean or replace it. Next, check the battery-cable connections to the engine block and starter solenoid and the fuse panel. You may have a blown fuse. Then give the rest of the boat’s electrical wiring a onceover. Finally, don’t make one of the most common mistakes—forgetting to open the vent on your fuel tank.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("ROUGH AT IDLE")]), _vm._v(" While the motor is idling, turn the low-speed jet screw in and out for a bit on each carburetor to loosen any debris. See your service manual for jet-screw locations and factory settings. If this doesn’t do it, there might be an ignition problem. Clean or replace spark plugs as needed. When I first start my motor, I always check to make sure there’s a telltale stream of cooling water being discharged from the rear. If that stream isn’t happening, the motor has to be shut down immediately before it overheats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DEATH AT SPEED")]), _vm._v(" Sometimes a motor that seems to idle just fine at the dock will surge or just plain die when you’re under way at midrange rpm. While running the motor in the problem rpm range, have a buddy rapidly squeeze the fuel-primer bulb a few times. If this extra shot of fuel smooths the motor out, then you’ve got a fuel delivery problem. It might be as simple as a partly clogged fuel filter, which can be an easy fix.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p87.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t103"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t104"
    }
  }, [_vm._v("104 AVOID FOULED OUTBOARDS")])])]), _c('a', {
    attrs: {
      "id": "t104"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Avoid contaminating your outboard’s fuel system by purging the gas line before you start a motor that hasn’t been run recently. Disconnect the fuel line from the engine and hold the connector over an empty container. Use a screwdriver to depress the plunger in the connector and squeeze the primer bulb repeatedly to pump out contaminated fuel that has been lying in the line.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p87a.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t104"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t105"
    }
  }, [_vm._v("105 SAVE GAS")])])]), _c('a', {
    attrs: {
      "id": "t105"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wasted fuel means less time on the water per tank and, of course, wasted money . . . gas prices don’t seem to be going down any time soon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GET CLOSE")]), _vm._v(" Launch close to the area you intend to fish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SLOW DOWN")]), _vm._v(" Minimize running flat out. Once your boat is on plane, throttle back to 4,500 rpm or so and use power trim to reduce drag and fuel consumption.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("LOSE WEIGHT")]), _vm._v(" Not even the pros need to bring 400 pounds of jigs and worm sinkers. So pare down your tackle. Also keep your live well plugged until you’ve caught a fish to avoid dragging extra water weight. Remember, a gallon of gas weighs 6 pounds, and many bass boats have fuel capacities exceeding 50 gallons. Unless you really need to, don’t fill your tank beyond one-half full. Finally, weigh in your fishing buddy before each trip; if he gains any pounds, hit him with a fuel surcharge.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p88.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t105"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t106"
    }
  }, [_vm._v("106 BACK YOUR TRAILER EASILY")])])]), _c('a', {
    attrs: {
      "id": "t106"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Backing a boat trailer down a ramp isn’t all that hard, but it does take practice. The key fact to keep in mind is that the trailer will always go in the opposite direction to the tow vehicle. This causes a great deal of confusion for newbies and is one of the main reasons you see guys wrestling a trailer that seems to have a mind of its own. Here’s an easy way to master this maneuver:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p88a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("GO SOLO")]), _vm._v(" Before you go anywhere near the water, practice your moves in a big, empty parking lot—the kind of place you’d go to teach your kid how to drive. Shift into reverse and then place your left hand on the bottom of the steering wheel. When you move your hand to the right (which turns the steering wheel and the front tires to the left), the trailer will move to the right (A). When you move your hand to the left . . . you guessed it. The wheel and front tires go right, the trailer moves left (B).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TAKE IT SLOW")]), _vm._v(" Most beginners back up too fast at first. Go slowly and, if the trailer starts to move in the wrong direction, stop. Pull up, straighten the trailer, and start again. Trying to correct a wayward trailer in motion will only make matters worse. Once you master the parking lot, you’re ready for the ramp.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t106"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t107"
    }
  }, [_vm._v("107 PROTECT YOUR TRAILER LIGHTS")])])]), _c('a', {
    attrs: {
      "id": "t107"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The lights on your boat trailer probably aren’t top in your mind when you think about important safety gear, but, in fact, they’re pretty essential. And they’re vulnerable, since electricity and water have a problematic relationship at best. Here’s how to keep them going strong so you can worry about far more interesting things.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p89.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("COOL DOWN")]), _vm._v(" Anglers trailering a boat to a launch ramp often forget that boat-trailer lights can burn out when the hot bulbs are submerged in water. After driving even a short distance, the trailer lights need time to simmer down. To do this properly, disconnect the trailer’s electrical wiring plug from the vehicle and let the bulbs cool as you load gear into the boat before launching. Hang the wiring plug over a high point so that it won’t get dunked.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p89a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("STAY DRY")]), _vm._v(" Even better, prevent shorting by rigging your trailer’s wiring so that no junctions or terminals are ever submerged. You can do this by elevating the lights on upright poles bolted to the frame. Don’t join the wires in a Y-formation on the trailer body. Instead, run separate wires from each taillight all the way to the vehicle plug. For extra protection, use an outdoor extension cord rather than standard electrical wire.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p89b.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t107"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t108"
    }
  }, [_vm._v("108")])]), _c('a', {
    attrs: {
      "id": "t108"
    }
  }, [_vm._v(" KNOW YOUR: "), _c('b', [_vm._v("STEELHEAD")])])]), _c('a', {
    attrs: {
      "id": "t108"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Steelhead are actually rainbow trout; what makes them different is that they live in saltwater and run back into freshwater rivers to spawn. Because they have to tough it out in the ocean and dine on more nutrient-rich saltwater forage, they grow very large and fight a whole lot harder than the average freshwater rainbow. Their name comes from their steel or chrome colorations, not found on other rainbows. True salt-running steelhead are native to the Pacific Northwest, but in the 1960s, they were also introduced to the Great Lakes. Though these fish don’t make it to the ocean, every spring and fall they run up rivers and creeks that drain into lakes from New York to Michigan. Hooking a steelhead isn’t all that difficult; they fall most often to natural salmon egg sacks, salmon egg flies, streamer flies swung in the current, or crankbaits. The real challenge is landing one, as they’re known to rip miles of line off a reel, run into root snarls and rock piles, and do whatever they can to shake the hook. Most steelhead hooked in rivers require the angler to chase them downstream for a chance at netting.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t108"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t109"
    }
  }, [_vm._v("109 FIGHT CORROSION")])])]), _c('a', {
    attrs: {
      "id": "t109"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A corroded ground can short out trailer lights. Sand the contact down to fresh metal, drill a hole in the trailer tongue, and put a stainless-steel screw through the end of the ground-wire terminal.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p90.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t109"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t110"
    }
  }, [_vm._v("110 GIVE ’EM THE SLIP BOBBER")])])]), _c('a', {
    attrs: {
      "id": "t110"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slip-floats are normally used by crappie and walleye fishermen to quickly adjust the depth at which they’re fishing a live minnow. But using one from a belly boat allows you to search for largemouths while helping you map out the lake or pond by serving as a makeshift depthfinder. First, estimate the average depth of the area you’re fishing and set the float stop on your line to that length. Now fan-cast the area with a weedless, skirted jig. If the float lies on its side (A), your jig is on the bottom. If it stands perpendicular (B), you’ve found deeper water. As you hop the jig back, keep an eye on the float, noting whether it’s lying vertically or horizontally. By doing so, you can determine where humps, stumps, and ledges are located. If the float jerks under abruptly, set the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p91.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t110"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t111"
    }
  }, [_vm._v("111 BELLY UP TO A BASS")])])]), _c('a', {
    attrs: {
      "id": "t111"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Belly boats are not only cheap; they also offer an element of stealth not easily achieved in a motorized boat. You can quietly kick into hard-to-reach pad clusters and stick-strewn coves where big bass live. In addition, a belly boat lets you present lures in new ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anglers on bass boats typically set up on the outside of lily-pad clusters, tossing lures into the pads and working them back to open water. With a belly boat, you can reverse that approach to hook more fish. Kick your way gently into the pads (A) just far enough to get your lure into open water with a long cast. Once you’re in place, keep still and wait 10 to 15 minutes for the area to settle, as you might have spooked some fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cast frog lures or buzzbaits into open water and retrieve into the pads. With frogs or poppers, be sure to stop the retrieve right on the edge of the vegetation for a moment or two to simulate forage trying to move into the cover. This tactic is particularly deadly early in the morning, when forage species begin moving, so get out before dawn breaks.")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t111"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t112"
    }
  }, [_vm._v("112 DRAG A WORM")])])]), _c('a', {
    attrs: {
      "id": "t112"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The slow speed at which a belly boat moves while you kick is just right for dragging a long soft-plastic worm with a curly tail. Trolling would be too tiring to do all day, but pulling a lure as you move from spot to spot can both catch you more fish and help you find areas where bass are holding in deeper water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep a 6- to 10-inch curly-tailed worm rigged with a wide-gap hook within reach. When you’re ready to move, tie it on with no weight, make a long cast, then let out another 15 feet of line. As you kick, hold the rod low to the water. At maximum speed, the worm will gently flutter behind you in the middle of the water column (B). If you slow down, it will fall. If you want to probe deep structure, just stop kicking and let the lure touch down (C). When you start moving again, the worm rising up off the bottom can provoke a strike.")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p92-93.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "t112"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col1"
  })])]), _c('b', [_c('a', {
    attrs: {
      "id": "t113"
    }
  }, [_vm._v("113 HAVE A G’DAY, MATE")])])]), _c('a', {
    attrs: {
      "id": "t113"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’re on vacation in a tropical locale and you’ve shelled out the coin for an expensive tuna charter. The captain is likely just going to run the boat all day while the mate does all the work for you. So how do you compensate him? It can be an awkward situation, but here are some rules to remember. Plan on tipping the mate on an offshore boat at least $50—at the bare minimum. Always factor in his performance. Was he friendly and helpful throughout the day, teaching you what to do instead of yelling orders? If you made a mistake, was he calm and collected or upset? Captains and mates are there to make your trip as enjoyable as possible and make you feel comfortable, even if the fishing is slow or a catch doesn’t make it to the boat. A mate who really works hard to get you on the fish by changing baits constantly and coaching you through every step deserves a little extra. Remember, a tip could be the only money a mate makes. Ask yourself if you’d like to fish with that mate again and you’ll often have your answer in regard to tipping a little or a lot.")])])]), _c('a', {
    attrs: {
      "id": "t113"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833b135e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 72
// module chunks = 0